// Hebrew translations
import type { Translations } from './en';

const he: Translations = {
    // --- Navigation / Shell ---
    'nav.collection': 'האוסף שלי',
    'nav.dashboard': 'לוח בקרה',
    'nav.inventory': 'מלאי',
    'nav.addItem': 'הוסף פריט',
    'nav.batchAdd': 'הוספה מרוכזת',
    'nav.library': 'ספריה',
    'nav.health': 'תחזוקה',
    'nav.stats': 'סטטיסטיקה',
    'nav.duplicates': 'כפולים',
    'nav.activity': 'פעילות',
    'nav.messages': 'הודעות',
    'nav.community': 'קהילה',
    'nav.showroom': 'תצוגה',
    'nav.reference': 'עזרה',
    'nav.userGuide': 'מדריך למשתמש',
    'nav.admin': 'ניהול',
    'nav.about': 'אודות',
    'nav.adminPanel': 'ממשק ניהול',
    'nav.settings': 'הגדרות',
    'nav.logout': 'התנתק',
    'nav.switchTheme': 'החלף ערכת נושא',
    'footer.rights': 'כל הזכויות שמורות.',
    'footer.builtBy': 'נבנה על ידי אסף סער.',
    'footer.terms': 'תנאי שימוש',
    'footer.privacy': 'מדיניות פרטיות',
    'footer.refund': 'מדיניות החזרים',

    // --- Breadcrumbs ---
    'breadcrumb.dashboard': 'לוח בקרה',
    'breadcrumb.inventory': 'מלאי',
    'breadcrumb.showroom': 'תצוגה',
    'breadcrumb.newItem': 'פריט חדש',
    'breadcrumb.batchAdd': 'הוספה מרוכזת',
    'breadcrumb.library': 'ספריה',
    'breadcrumb.health': 'תחזוקה',
    'breadcrumb.settings': 'הגדרות',
    'breadcrumb.userGuide': 'מדריך למשתמש',
    'breadcrumb.admin': 'ניהול',
    'breadcrumb.itemDetail': 'פרטי פריט',
    'breadcrumb.stats': 'סטטיסטיקה',
    'breadcrumb.activity': 'פיד פעילות',
    'breadcrumb.messages': 'הודעות',
    'breadcrumb.duplicates': 'כפולים',

    // --- Landing page ---
    'landing.heroHeadline': '',
    'landing.heroAccent': 'האוסף',
    'landing.heroHeadlineSuffix': ' שלך, מאורגן ושמור',
    'landing.heroSub': 'מחשבי רטרו, מצלמות וינטג\', שעונים, ציוד Hi-Fi — או כל אוסף אישי, ממטבעות ובולים ועד מכוניות צעצוע. לכל פריט יש סיפור. כאן שומרים אותו.',
    'landing.goToDashboard': 'אל לוח הבקרה',
    'landing.getStarted': 'התחל בחינם',
    'landing.featuresTitle': 'כל מה שאתה צריך',
    'landing.feature1Title': 'קטלג וארגן',
    'landing.feature1Desc': 'בנה מלאי מפורט במספר כספות — כל אחת מותאמת לסוג האוסף שלה עם שדות, קטגוריות ופלטפורמות ייחודיים.',
    'landing.feature2Title': 'עקוב אחרי מצב',
    'landing.feature2Desc': 'תעד את מצבו של כל פריט — מ"חדש באריזה" ועד "אהוב ומשומש" — כדי שתמיד תדע מה מצב האוסף שלך.',
    'landing.feature3Title': 'ייצא ושתף',
    'landing.feature3Desc': 'ייצא את המלאי המלא שלך כ-CSV, JSON, או קטלוג PDF מעוצב לגיבויים, רשומות ביטוח, או שיתוף עם אספנים אחרים.',
    'landing.vaultsTitle': 'אפליקציה אחת, כספות מרובות',
    'landing.vaultsSub': 'כל כספת בנויה במיוחד לסוג האוסף שלה — עם הקטגוריות, השדות והפרומפטים הנכונים.',
    'landing.vaultRetroComputers': 'מחשבי רטרו',
    'landing.vaultRetroComputersDesc': 'מחשבים וינטג\'יים, קונסולות, ציוד היקפי ותוכנות. עקוב אחרי מעבדים, זיכרון, מערכות וידאו ועוד.',
    'landing.vaultVintageCameras': 'מצלמות וינטג\'',
    'landing.vaultVintageCamerasDesc': 'מצלמות פילם, עדשות וציוד צילום אנלוגי. עקוב אחרי תושבות עדשה, פורמט פילם ומהירויות תריס.',
    'landing.vaultWatches': 'שעונים',
    'landing.vaultWatchesDesc': 'שעונים מכניים וקוורץ. עקוב אחרי מנגנונים, חומרי מארז, סיבוכים והיסטוריית שירות.',
    'landing.vaultRetroAudio': 'אודיו רטרו / Hi-Fi',
    'landing.vaultRetroAudioDesc': 'פטיפונים, מגברים, רמקולים וטייפים. עקוב אחרי הספק, עכבה וסוגי שפופרות.',
    'landing.footer': 'כל הזכויות שמורות.',
    'landing.switchTheme': 'החלף ערכת נושא',

    // --- Login ---
    'login.subtitle': 'מנהל מלאי מחשוב רטרו',
    'login.tabLogin': 'התחברות',
    'login.tabRegister': 'הרשמה',
    'login.displayName': 'שם תצוגה',
    'login.email': 'דוא"ל',
    'login.password': 'סיסמה',
    'login.placeholderName': 'RetroFan42',
    'login.placeholderEmail': 'user@example.com',
    'login.placeholderPassword': 'מינימום 8 תווים',
    'login.loading': 'טוען...',
    'login.createAccount': 'צור חשבון',
    'login.somethingWentWrong': 'משהו השתבש',

    // --- Dashboard ---
    'dashboard.title': 'לוח בקרה',
    'dashboard.totalItems': 'סה"כ פריטים',
    'dashboard.working': 'תקינים',
    'dashboard.alerts': 'התראות',
    'dashboard.urgentAlerts': 'התראות דחופות',
    'dashboard.viewAll': 'צפה בהכל',
    'dashboard.recentlyAdded': 'נוספו לאחרונה',
    'dashboard.emptyTitle': 'הכספת שלך ריקה',
    'dashboard.emptyDesc': 'הוסף את פריט הרטרו הראשון שלך כדי להתחיל.',
    'dashboard.addFirstItem': 'הוסף פריט ראשון',

    // --- Inventory list ---
    'inventory.title': 'מלאי',
    'inventory.exportCsv': 'ייצוא CSV',
    'inventory.exportJson': 'ייצוא JSON',
    'inventory.exportPdf': 'ייצוא PDF',
    'inventory.addItem': 'הוסף פריט',
    'inventory.searchPlaceholder': 'חיפוש פריטים...',
    'inventory.allCategories': 'כל הקטגוריות',
    'inventory.allPlatforms': 'כל הפלטפורמות',
    'inventory.allConditions': 'כל המצבים',
    'inventory.allVideoSystems': 'כל מערכות הוידאו',
    'inventory.allSubcategories': 'כל תתי-הקטגוריות',
    'inventory.allUsers': 'כל המשתמשים',
    'inventory.myItems': 'הפריטים שלי',
    'inventory.clearAll': 'נקה הכל',
    'inventory.clearFilters': 'נקה מסננים',
    'inventory.resetFilters': 'אפס מסננים',
    'inventory.noMatch': 'אין פריטים התואמים את המסננים',
    'inventory.emptyVault': 'הכספת שלך ריקה',
    'inventory.noMatchDesc': 'נסה לנקות חלק מהמסננים כדי לראות תוצאות נוספות.',
    'inventory.emptyDesc': 'הוסף את פריט הרטרו הראשון שלך כדי להתחיל.',
    'inventory.loadingInventory': 'טוען מלאי...',
    'inventory.gridView': 'תצוגת רשת',
    'inventory.tableView': 'תצוגת טבלה',
    'inventory.sortBy': 'מיין לפי',
    'inventory.sort.createdAt': 'תאריך הוספה',
    'inventory.sort.updatedAt': 'עדכון אחרון',
    'inventory.sort.name': 'שם',
    'inventory.sort.category': 'קטגוריה',
    'inventory.sort.platform': 'פלטפורמה',
    'inventory.sort.condition': 'מצב',
    'inventory.sort.subcategory': 'תת-קטגוריה',
    'inventory.sort.acquisitionDate': 'תאריך רכישה',
    'inventory.sort.acquisitionPrice': 'מחיר רכישה',
    'inventory.sort.launchDate': 'תאריך השקה',
    'inventory.sort.launchPrice': 'מחיר השקה',

    // --- Inventory detail ---
    'itemDetail.backToInventory': 'חזרה למלאי',
    'itemDetail.backToShowroom': 'חזרה לתצוגת הקהילה',
    'itemDetail.editItem': 'עריכת פריט',
    'itemDetail.addNewItem': 'הוספת פריט חדש',
    'itemDetail.removeFromShowroom': 'הסר מהתצוגה',
    'itemDetail.showroom': 'תצוגה',
    'itemDetail.edit': 'עריכה',
    'itemDetail.delete': 'מחיקה',
    'itemDetail.noImageUploaded': 'לא הועלתה תמונה',
    'itemDetail.uploadNew': 'העלאת תמונה',
    'itemDetail.editImage': 'עריכת תמונה',
    'itemDetail.platform': 'פלטפורמה',
    'itemDetail.category': 'קטגוריה',
    'itemDetail.subcategory': 'תת-קטגוריה',
    'itemDetail.condition': 'מצב',
    'itemDetail.quantity': 'כמות',
    'itemDetail.acquired': 'תאריך רכישה',
    'itemDetail.price': 'מחיר',
    'itemDetail.owner': 'בעלים',
    'itemDetail.location': 'מיקום',
    'itemDetail.added': 'נוסף',
    'itemDetail.cpu': 'מעבד',
    'itemDetail.memory': 'זיכרון',
    'itemDetail.launchInfo': 'מידע השקה',
    'itemDetail.launchPrice': 'מחיר השקה',
    'itemDetail.inflationAdjusted': 'מתואם אינפלציה',
    'itemDetail.customNotes': 'הערות',
    'itemDetail.files': 'קבצים',
    'itemDetail.deleteItemTitle': 'מחיקת פריט',
    'itemDetail.deleteConfirm': 'האם אתה בטוח שברצונך למחוק את',
    'itemDetail.deleteWarning': 'פעולה זו אינה ניתנת לביטול.',
    'itemDetail.deleting': 'מוחק...',
    'itemDetail.cancel': 'ביטול',
    'itemDetail.loadingItem': 'טוען פריט...',
    'itemDetail.itemNotFound': 'הפריט לא נמצא.',
    'itemDetail.createItem': 'צור פריט',
    'itemDetail.name': 'שם',
    'itemDetail.description': 'תיאור',
    'itemDetail.reanalyze': 'ניתוח מחדש',
    'itemDetail.reviewTitle': 'סקירת ניתוח AI',
    'itemDetail.reviewField': 'שדה',
    'itemDetail.reviewCurrent': 'נוכחי',
    'itemDetail.reviewSuggested': 'מוצע',
    'itemDetail.reviewAcceptSelected': 'החל נבחרים',
    'itemDetail.reviewDismiss': 'ביטול',
    'itemDetail.reviewSelectAll': 'בחר הכל',
    'itemDetail.reviewNoChanges': 'לא נמצאו הבדלים — הצעות ה-AI תואמות לערכים הנוכחיים.',
    'itemDetail.reviewConfidence': 'רמת ביטחון',
    'itemDetail.reviewLaunchCurrency': 'מטבע השקה',
    'itemDetail.reanalyzeFailed': 'ניתוח התמונה נכשל. נסה שוב.',
    'itemDetail.reanalyzeApplied': 'הצעות ה-AI הוחלו בהצלחה.',
    'itemDetail.imageSaved': 'התמונה נשמרה',
    'itemDetail.imageUploadFailed': 'שמירת התמונה נכשלה',

    // --- גלריית תמונות ---
    'imageGallery.setPrimary': 'הגדר כראשית',
    'imageGallery.deleteImage': 'התמונה נמחקה',
    'imageGallery.primaryBadge': 'ראשית',
    'imageGallery.addImage': 'הוסף תמונה',
    'imageGallery.noImages': 'לא הועלו תמונות',
    'imageGallery.confirmDelete': 'האם אתה בטוח שברצונך למחוק תמונה זו?',
    'imageGallery.maxReached': 'הגעת למספר המרבי של תמונות',

    // --- Item Form ---
    'itemForm.name': 'שם',
    'itemForm.namePlaceholder': 'לדוגמה, Commodore 64 Rev B',
    'itemForm.nameRequired': 'שם הוא שדה חובה',
    'itemForm.category': 'קטגוריה',
    'itemForm.platform': 'פלטפורמה',
    'itemForm.subcategory': 'תת-קטגוריה',
    'itemForm.subcategoryPlaceholder': 'לדוגמה, Amiga 500, משחק, כרטיס מסך',
    'itemForm.condition': 'מצב',
    'condition.mint': 'כמו חדש',
    'condition.excellent': 'מצוין',
    'condition.good': 'טוב',
    'condition.fair': 'סביר',
    'condition.poor': 'גרוע',
    'condition.parts': 'חלקים',
    'category.Computer': 'מחשב',
    'category.Console': 'קונסולה',
    'category.Peripheral': 'ציוד היקפי',
    'category.Software': 'תוכנה',
    'category.Documentation': 'תיעוד',
    'category.Media': 'מדיה',
    'category.Component': 'רכיב',
    'category.Accessory': 'אביזר',
    'category.Other': 'אחר',
    'platform.3DO': '3DO',
    'platform.Amiga': 'Amiga',
    'platform.Amstrad': 'Amstrad',
    'platform.Apple': 'Apple',
    'platform.Atari': 'Atari',
    'platform.Atari 2600': 'Atari 2600',
    'platform.Atari Jaguar': 'Atari Jaguar',
    'platform.BBC Micro': 'BBC Micro',
    'platform.ColecoVision': 'ColecoVision',
    'platform.Commodore': 'Commodore',
    'platform.Game Boy': 'Game Boy',
    'platform.Game Boy Advance': 'Game Boy Advance',
    'platform.IBM PC': 'IBM PC',
    'platform.Intellivision': 'Intellivision',
    'platform.MSX': 'MSX',
    'platform.N64': 'N64',
    'platform.NES': 'NES',
    'platform.Neo Geo': 'Neo Geo',
    'platform.PS1': 'PlayStation',
    'platform.Sega Genesis': 'Sega Genesis',
    'platform.Sega Master System': 'Sega Master System',
    'platform.Sega Saturn': 'Sega Saturn',
    'platform.SNES': 'SNES',
    'platform.Spectrum': 'Spectrum',
    'platform.Tandy': 'Tandy',
    'platform.TI-99': 'TI-99',
    'platform.TurboGrafx-16': 'TurboGrafx-16',
    'platform.Other': 'אחר',
    'itemForm.quantity': 'כמות',
    'itemForm.description': 'תיאור',
    'itemForm.descriptionPlaceholder': 'הערות על פריט זה...',
    'itemForm.location': 'מיקום',
    'itemForm.locationPlaceholder': 'למשל מדף A, חדר אחסון, ויטרינה',
    'itemForm.acquisitionDate': 'תאריך רכישה',
    'itemForm.acquisitionPrice': 'מחיר רכישה',
    'itemForm.invalidPrice': 'פורמט מחיר לא תקין',
    'itemForm.currency': 'מטבע',
    'itemForm.videoSystem': 'מערכת וידאו',
    'itemForm.specsSection': 'מפרט',
    'itemForm.cpu': 'מעבד',
    'itemForm.cpuPlaceholder': 'לדוגמה, MOS 6510 @ 1 MHz',
    'itemForm.memory': 'זיכרון',
    'itemForm.memoryPlaceholder': 'לדוגמה, 64 KB RAM',
    'itemForm.launchInfoSection': 'מידע השקה מקורי',
    'itemForm.launchDate': 'תאריך השקה',
    'itemForm.launchDatePlaceholder': 'לדוגמה, 1982-08',
    'itemForm.launchPrice': 'מחיר השקה',
    'itemForm.launchPriceCurrency': 'מטבע',
    'itemForm.inflationAdjustedPrice': 'מתואם אינפלציה (USD)',
    'itemForm.customNotes': 'הערות',
    'itemForm.customNotesPlaceholder': 'הערות נוספות על פריט זה...',
    'itemForm.otherPlaceholder': 'פרט...',
    'itemForm.customFields': 'שדות מותאמים',
    'itemForm.customFieldName': 'שם שדה',
    'itemForm.customFieldValue': 'ערך',
    'itemForm.addCustomField': 'הוסף שדה',
    'videoSystem.PAL': 'PAL',
    'videoSystem.NTSC': 'NTSC',
    'videoSystem.SECAM': 'SECAM',
    'videoSystem.Dual': 'כפול',
    'videoSystem.Other': 'אחר',
    'itemForm.saving': 'שומר...',
    'itemForm.saveItem': 'שמור פריט',
    'itemForm.cancel': 'ביטול',
    'itemForm.updateItem': 'עדכן פריט',

    // --- Item Card ---
    'itemCard.noImage': 'אין תמונה',
    'itemCard.qty': 'כמות',

    // --- Item Table ---
    'itemTable.name': 'שם',
    'itemTable.platform': 'פלטפורמה',
    'itemTable.category': 'קטגוריה',
    'itemTable.subcategory': 'תת-קטגוריה',
    'itemTable.condition': 'מצב',
    'itemTable.qty': 'כמות',
    'itemTable.status': 'סטטוס',
    'itemTable.added': 'נוסף',
    'itemTable.owner': 'בעלים',
    'itemTable.empty': 'לא נמצאו פריטים. התחל לבנות את האוסף שלך!',

    // --- Showroom ---
    'showroom.title': 'תצוגה',
    'showroom.searchPlaceholder': 'חיפוש פריטים בתצוגה...',
    'showroom.allCategories': 'כל הקטגוריות',
    'showroom.allPlatforms': 'כל הפלטפורמות',
    'showroom.allConditions': 'כל המצבים',
    'showroom.clearAll': 'נקה הכל',
    'showroom.clearFilters': 'נקה מסננים',
    'showroom.favoritesOnly': 'הצג מועדפים בלבד',
    'showroom.showAll': 'הצג את כל הפריטים',
    'showroom.includeMyItems': 'כלול את הפריטים שלי',
    'showroom.hideMyItems': 'הסתר את הפריטים שלי',
    'showroom.noMatch': 'אין פריטים התואמים את המסננים',
    'showroom.emptyTitle': 'עדיין אין פריטים בתצוגה',
    'showroom.noMatchDesc': 'נסה לנקות חלק מהמסננים כדי לראות תוצאות נוספות.',
    'showroom.emptyDesc': 'כאשר משתמשים יציגו פריטים מהאוסף שלהם, הם יופיעו כאן.',
    'showroom.loadingShowroom': 'טוען תצוגה...',

    // --- Library ---
    'library.title': 'הספריה',
    'library.insertDisk': 'הכנס דיסק',
    'library.cancel': 'ביטול',
    'library.insertDiskHeader': '=== הכנס דיסק ===',
    'library.fileName': 'שם קובץ',
    'library.fileType': 'סוג קובץ',
    'library.platform': 'פלטפורמה',
    'library.any': 'כלשהו',
    'library.description': 'תיאור',
    'library.optionalDescription': 'תיאור אופציונלי',
    'library.chooseFile': 'בחר קובץ',
    'library.noFileChosen': 'לא נבחר קובץ',
    'library.loading': 'טוען...',
    'library.loadCommand': 'LOAD "*",8,1',
    'library.searchPlaceholder': 'חיפוש קבצים...',
    'library.allTypes': 'כל הסוגים',
    'library.allPlatforms': 'כל הפלטפורמות',
    'library.loadingLibrary': 'טוען ספריה...',
    'library.readyNoFiles': 'READY.\nלא נמצאו קבצים.',
    'library.download': 'הורדה',
    'library.deleteFile': 'מחיקה',
    'library.prev': 'הקודם',
    'library.next': 'הבא',

    // --- Health ---
    'health.title': 'דופק תחזוקה',
    'health.loadingHealth': 'טוען נתוני תחזוקה...',
    'health.noData': 'אין נתוני תחזוקה זמינים.',
    'health.totalItems': 'סה"כ פריטים',
    'health.working': 'תקינים',
    'health.recapProgress': 'התקדמות ריקאפ',
    'health.activeRetrobright': 'רטרוברייט פעיל',
    'health.totalLinks': 'סה"כ קישורים',
    'health.conditionBreakdown': 'פירוט מצבים',
    'health.urgentAlerts': 'התראות דחופות',

    // --- Settings ---
    'settings.title': 'הגדרות',
    'settings.profile': 'פרופיל',
    'settings.appearance': 'מראה',
    'settings.language': 'שפה',
    'settings.inventory': 'מלאי',
    'settings.defaultView': 'תצוגת ברירת מחדל',
    'settings.itemsPerPage': 'פריטים בעמוד',
    'settings.about': 'אודות',
    'settings.aboutLine1': 'SiliconVault - מנהל מלאי מחשוב רטרו',
    'settings.aboutLine2': 'משמרים את עידן ה-8 ביט, פריט אחרי פריט.',

    // --- About page ---
    'about.appDescription': 'מערכת ניהול מלאי מקיפה לאספנים. מחשבי רטרו, מצלמות וינטג׳, שעונים, ציוד Hi-Fi — קטלג את האוסף שלך, עקוב אחר מצב והיסטוריה, ונהל תיעוד בכספות ייעודיות.',
    'about.featuresTitle': 'תכונות',
    'about.feat1': 'מלאי רב-כספות עם קטגוריות, פלטפורמות ושדות ייחודיים לכל כספת',
    'about.feat2': 'קישור פריטים למיפוי חיבורים בין חלקים קשורים באוסף',
    'about.feat3': 'מעקב ריקאפ קבלים עם העלאת סכמות וסטטוס לכל רכיב',
    'about.feat4': 'היסטוריית שירות ומעקב תחזוקה עם תיעוד לפני ואחרי',
    'about.feat6': 'ספריית מסמכים עם אימות קבצים, גיבוב SHA-256 ושיוך לפריטים',
    'about.feat7': 'לוח בריאות תחזוקה עם התראות אוטומטיות ורמות חומרה',
    'about.feat8': 'עורך תמונות מובנה עם חיתוך, סיבוב, זום והיפוך',
    'about.feat9': 'ייצוא ל-CSV, JSON, או PDF לגיבויים ודוחות',
    'about.feat10': 'בקרת גישה מבוססת תפקידים עם רמות מנהל ומשתמש',
    'about.feat11': 'תמיכה מלאה באנגלית ועברית (כולל RTL)',
    'about.developerTitle': 'מפתח',
    'about.developerName': 'אסף סער',
    'about.developerLinkedIn': 'התחברו איתי בלינקדאין',
    'about.developerBio': 'מנהל בכיר בתעשיית התוכנה המתמחה בניהול מוצר, ואספן מחשוב רטרו מושבע מאז ימי ה-Commodore 64. בזמן הפנוי המועט שנותר לי, אני בונה פרויקטים כמו SiliconVault — נבנה לחלוטין עבור הקהילה, על ידי אספן שמחזיר לקהילה.',
    'about.builtWith': 'נבנה עם',
    'about.licenseTitle': 'רישיון ותנאים',
    'about.licenseBody': 'SiliconVault היא תוכנה קניינית. פלטפורמת האינטרנט מציעה שכבה חינמית עם תכונות ליבה. מנויי Pro ואפליקציית שולחן העבודה פותחים יכולות נוספות — ראו siliconvault.app לפרטים.',
    'about.communityBody': 'הפלטפורמה נבנתה עבור אספנים, על ידי אספן חובב בעצמו. ניהול אוספים, חלון ראווה, מסחר וכל תכונות הקהילה קיימים כדי שחובבים יתחברו וישתפו את התשוקה שלהם. הכל כאן נעשה על ידי המשתמשים, עבור המשתמשים.',
    'about.disclaimerTitle': 'הצהרת אחריות',
    'about.disclaimerBody': 'SiliconVault היא פלטפורמת מידע בלבד. כל העסקאות, המסחר והאינטראקציות מתבצעים אך ורק בין הצדדים (peer-to-peer). בעל הפלטפורמה אינו מאמת את מצב הפריטים, זהות המשתמשים או דיוק נתוני השוק, ואינו נושא באחריות לתוכן שנוצר על ידי משתמשים, הפסד כספי או סכסוכים. בטיחות החומרה היא באחריות המשתמש; בעל הפלטפורמה אינו אחראי לנזקי רכוש או פגיעה גופנית הנובעים משימוש או תיקון של ציוד וינטג\'י. השירות ניתן כמות שהוא (as-is), ללא אחריות מכל סוג.',
    'about.disclaimerTos': 'השימוש ב-SiliconVault מהווה הסכמה ל{terms} ול{privacy} שלנו.',
    'about.privacyTitle': 'הפרטיות שלך',
    'about.privacyBody': 'המידע שלך לעולם אינו נמכר, משותף עם צדדים שלישיים או משמש לפרסום. האוספים פרטיים כברירת מחדל — אתה בוחר מה לשתף דרך חלון הראווה. איננו מאחסנים או מציגים נתוני מיקום גיאוגרפי מדויקים של אוספים.',
    'about.aiTitle': 'גילוי בינה מלאכותית',
    'about.aiBody': 'בינה מלאכותית משמשת לסיוע בזיהוי פריטים מתמונות ויצירת מפרטים. נתוני האוסף האישי שלך נשארים שלך ואינם משמשים לאימון מודלים של AI.',
    'about.dataTitle': 'ניידות מידע',
    'about.dataBody': 'תוכל לייצא את כל האוסף שלך ל-CSV, JSON, או קטלוג PDF בכל עת מדף המלאי. המידע שלך תמיד שלך לקחת.',
    'about.techTitle': 'תשתית',
    'about.techBody': 'מתארח על Vercel עם מסד נתונים Neon PostgreSQL. אימות באמצעות JWT tokens מאובטחים בעוגיות httpOnly עם הצפנת סיסמאות bcrypt. כל החיבורים מוצפנים באמצעות TLS.',
    'settings.accountDetails': 'פרטי חשבון',
    'settings.displayName': 'שם תצוגה',
    'settings.email': 'דוא"ל',
    'settings.saving': 'שומר...',
    'settings.saveChanges': 'שמור שינויים',
    'settings.profileUpdated': 'הפרופיל עודכן',
    'settings.failedToUpdateProfile': 'עדכון הפרופיל נכשל',
    'settings.changePassword': 'שנה סיסמה',
    'settings.currentPassword': 'סיסמה נוכחית',
    'settings.newPassword': 'סיסמה חדשה',
    'settings.changing': 'משנה...',
    'settings.passwordChanged': 'הסיסמה שונתה',
    'settings.failedToChangePassword': 'שינוי הסיסמה נכשל',
    'settings.confirmNewPassword': 'אימות סיסמה חדשה',
    'settings.passwordsDoNotMatch': 'הסיסמאות אינן תואמות',
    'settings.themeGreenPhosphor': 'זרחן ירוק (P1)',
    'settings.themeAmberPhosphor': 'זרחן כתום (P3)',
    'settings.themeCommodore': 'Commodore 64',
    'settings.themeAtari': 'Atari 800XL',
    'settings.themeSpectrum': 'ZX Spectrum',
    'settings.themeAmstrad': 'Amstrad CPC 464',
    'settings.themeAmiga': 'Amiga Workbench',
    'settings.themeVuMeter': 'VU Meter',
    'settings.themeBrushedAluminum': 'Brushed Aluminum',
    'settings.themeDarkroom': 'Darkroom',
    'settings.themeChromeLeather': 'Chrome & Leather',
    'settings.themeMidnightDial': 'Midnight Dial',
    'settings.themeGuilloche': 'Guilloché',
    'settings.themeReelToReel': 'סליל-לסליל',
    'settings.themeVinylGroove': 'חריץ ויניל',
    'settings.themeTubeGlow': 'זוהר שפופרת',
    'settings.themeKodachrome': 'קודכרום',
    'settings.themeFilmNoir': 'פילם נואר',
    'settings.themeCyanotype': 'ציאנוטייפ',
    'settings.themePatina': 'פטינה',
    'settings.themeRoseGold': 'זהב ורוד',
    'settings.themeLume': 'לומה',
    'settings.themeModernDark': 'מודרני כהה',
    'settings.themeModernLight': 'מודרני בהיר',
    'settings.showTicker': 'טיקר תצוגה',
    'settings.tickerOn': 'פעיל',
    'settings.tickerOff': 'כבוי',

    // --- Admin ---
    'admin.title': 'ניהול',
    'admin.accessDenied': 'הגישה נדחתה',
    'admin.accessDeniedMessage': 'רק מנהלים יכולים לגשת לממשק הניהול.',
    'admin.addUser': '+ הוסף משתמש',
    'admin.name': 'שם',
    'admin.email': 'דוא"ל',
    'admin.role': 'תפקיד',
    'admin.joined': 'הצטרף',
    'admin.you': 'אתה',
    'admin.resetPw': 'אפס סיסמה',
    'admin.ban': 'חסום',
    'admin.addUserTitle': 'הוספת משתמש',
    'admin.displayName': 'שם תצוגה',
    'admin.password': 'סיסמה',
    'admin.cancel': 'ביטול',
    'admin.adding': 'מוסיף...',
    'admin.userAddedSuccess': 'המשתמש נוסף בהצלחה',
    'admin.failedToAddUser': 'הוספת משתמש נכשלה',
    'admin.roleUpdated': 'התפקיד עודכן',
    'admin.failedToUpdateRole': 'עדכון התפקיד נכשל',
    'admin.resetPasswordTitle': 'איפוס סיסמה',
    'admin.resetPasswordDesc': 'הגדר סיסמה חדשה עבור',
    'admin.resetPasswordSuffix': '. הם יצטרכו להשתמש בסיסמה זו בהתחברות הבאה.',
    'admin.newPassword': 'סיסמה חדשה',
    'admin.confirmPassword': 'אימות סיסמה',
    'admin.repeatNewPassword': 'חזור על הסיסמה החדשה',
    'admin.passwordMinLength': 'הסיסמה חייבת להכיל לפחות 8 תווים',
    'admin.passwordsDoNotMatch': 'הסיסמאות אינן תואמות',
    'admin.resetting': 'מאפס...',
    'admin.resetPassword': 'אפס סיסמה',
    'admin.passwordResetFor': 'הסיסמה אופסה עבור',
    'admin.failedToResetPassword': 'איפוס הסיסמה נכשל',
    'admin.banUserTitle': 'חסימת משתמש',
    'admin.banConfirm': 'אתה עומד לחסום לצמיתות את',
    'admin.banWarn1': 'החשבון שלהם יימחק',
    'admin.banWarn2': 'כל פריטי המלאי שלהם יימחקו',
    'admin.banWarn3': 'כל התמונות שהועלו יוסרו',
    'admin.banIrreversible': 'פעולה זו אינה ניתנת לביטול.',
    'admin.banning': 'חוסם...',
    'admin.banAndDelete': 'חסום ומחק',
    'admin.bannedSuccess': 'נחסם וכל הנתונים שלו נמחקו',
    'admin.failedToBan': 'חסימת המשתמש נכשלה',
    'admin.loadingUsers': 'טוען משתמשים...',
    'admin.user': 'משתמש',
    'admin.adminRole': 'מנהל',
    'admin.lastLogin': 'התחברות אחרונה',
    'admin.never': 'אף פעם',
    'admin.items': 'פריטים',
    'admin.totalValue': 'שווי',
    'admin.loadingStats': 'טוען סטטיסטיקות...',
    'admin.statTotalUsers': 'סה"כ משתמשים',
    'admin.statTotalItems': 'סה"כ פריטים',
    'admin.statTotalValue': 'שווי כולל',
    'admin.statForTrade': 'להחלפה',
    'admin.statForSale': 'למכירה',
    'admin.statActiveTrades': 'הצעות פעילות',
    'admin.statNewThisMonth': 'חדשים החודש',
    'admin.statLibraryFiles': 'קבצי ספריה',
    'admin.statLibrarySize': 'גודל ספריה',
    'admin.statCriticalAlerts': 'התראות קריטיות',
    'admin.statUnresolvedAlerts': 'התראות פתוחות',
    'admin.statActiveRetrobright': 'רטרוברייט פעיל',
    'admin.sectionCommunity': 'קהילה',
    'admin.sectionSystem': 'מערכת',

    // Admin Tabs
    'admin.tabOverview': 'סקירה',
    'admin.tabUsers': 'משתמשים',
    'admin.tabInventory': 'מלאי',
    'admin.tabOffers': 'הצעות',

    // Admin User Search & Pagination
    'admin.searchUsersPlaceholder': 'חיפוש לפי שם או דוא"ל...',
    'admin.allRoles': 'כל התפקידים',
    'admin.prevPage': 'הקודם',
    'admin.nextPage': 'הבא',
    'admin.pageOf': 'עמוד {page} מתוך {totalPages}',
    'admin.viewInventory': 'צפה בפריטים',

    // Admin User Inventory Modal
    'admin.userInventoryTitle': 'המלאי של {name}',
    'admin.searchItemsPlaceholder': 'חיפוש פריטים...',
    'admin.noItemsFound': 'לא נמצאו פריטים.',
    'admin.loadingItems': 'טוען פריטים...',

    // Admin Offers Panel
    'admin.allStatuses': 'כל הסטטוסים',
    'admin.pending': 'ממתינה',
    'admin.accepted': 'אושרה',
    'admin.declined': 'נדחתה',
    'admin.withdrawn': 'בוטלה',
    'admin.searchOffersPlaceholder': 'חיפוש לפי שם משתמש...',
    'admin.offerFrom': 'מאת',
    'admin.offerTo': 'אל',
    'admin.offerStatus': 'סטטוס',
    'admin.offerItems': 'פריטים',
    'admin.offerMoney': 'מזומן',
    'admin.offerCreated': 'נוצר',
    'admin.offerActions': 'פעולות',
    'admin.forceWithdraw': 'בטל בכוח',
    'admin.forceWithdrawTitle': 'ביטול הצעה בכוח',
    'admin.forceWithdrawConfirm': 'לבטל הצעה זו בכוח? שני המשתמשים יקבלו התראה.',
    'admin.forceWithdrawing': 'מבטל...',
    'admin.forceWithdrawSuccess': 'ההצעה בוטלה בכוח',
    'admin.forceWithdrawFailed': 'ביטול ההצעה נכשל',
    'admin.noOffers': 'לא נמצאו הצעות.',
    'admin.loadingOffers': 'טוען הצעות...',

    // --- Peripheral Links ---
    'links.title': 'ציוד היקפי מחובר',
    'links.plugIn': '+ חבר',
    'links.loading': 'טוען חיבורים...',
    'links.noPeripherals': 'אין ציוד היקפי מחובר',
    'links.linkPeripheralTitle': 'חיבור ציוד היקפי',
    'links.searchItems': 'חיפוש פריטים',
    'links.searchPlaceholder': 'הקלד לחיפוש...',
    'links.linkType': 'סוג חיבור',
    'links.notes': 'הערות',
    'links.optionalNotes': 'הערות אופציונליות...',
    'links.cancel': 'ביטול',
    'links.linking': 'מחבר...',
    'links.createLink': 'צור חיבור',
    'links.unplug': 'נתק',

    // --- Capacitor / Recap ---
    'cap.title': 'סטטוס ריקאפ',
    'cap.addCap': '+ הוסף קבל',
    'cap.cancel': 'ביטול',
    'cap.noCapsMapped': 'לא מופו קבלים',
    'cap.designator': 'מזהה',
    'cap.value': 'ערך',
    'cap.type': 'סוג',
    'cap.status': 'סטטוס',
    'cap.voltage': 'מתח',
    'cap.add': 'הוסף',

    // --- Retrobright ---
    'retro.title': 'רטרוברייט',
    'retro.newProject': '+ פרויקט חדש',
    'retro.cancel': 'ביטול',
    'retro.projectName': 'שם הפרויקט',
    'retro.targetHours': 'שעות יעד',
    'retro.create': 'צור',
    'retro.loading': 'טוען פרויקטים...',
    'retro.noProjects': 'אין פרויקטי רטרוברייט',
    'retro.stopTimer': 'עצור טיימר',
    'retro.startTimer': 'התחל טיימר',
    'retro.complete': 'סיים',

    // --- Alerts ---
    'alerts.title': 'התראות תחזוקה',
    'alerts.addAlert': '+ הוסף התראה',
    'alerts.cancel': 'ביטול',
    'alerts.type': 'סוג',
    'alerts.severity': 'חומרה',
    'alerts.alertTitle': 'כותרת',
    'alerts.alertTitlePlaceholder': 'כותרת ההתראה',
    'alerts.description': 'תיאור',
    'alerts.optionalDetails': 'פרטים אופציונליים...',
    'alerts.alertDescription': 'תיאור',
    'alerts.optionalDescription': 'תיאור אופציונלי',
    'alerts.createAlert': 'צור התראה',
    'alerts.loading': 'טוען התראות...',
    'alerts.noActive': 'אין התראות פעילות',
    'alerts.noActiveAlerts': 'אין התראות פעילות',
    'alerts.resolve': 'פתור',
    'alerts.reopen': 'פתח מחדש',
    'alerts.capacitorCheck': 'בדיקת קבלים',
    'alerts.batteryCheck': 'בדיקת סוללה',
    'alerts.cleaning': 'ניקוי',
    'alerts.testing': 'בדיקה',
    'alerts.repair': 'תיקון',
    'alerts.other': 'אחר',

    // --- Image Editor ---
    'imageEditor.title': 'עריכת תמונה',
    'imageEditor.zoom': 'זום',
    'imageEditor.rotate': 'סיבוב',
    'imageEditor.rotateLeft': 'סובב שמאלה 90\u00B0',
    'imageEditor.rotateRight': 'סובב ימינה 90\u00B0',
    'imageEditor.flipH': 'הפוך אופקית',
    'imageEditor.flipV': 'הפוך אנכית',
    'imageEditor.reset': 'אפס את כל העריכות',
    'imageEditor.cancel': 'ביטול',
    'imageEditor.saving': 'שומר...',
    'imageEditor.applyAndUpload': 'החל והעלה',
    'imageEditor.free': 'חופשי',
    'imageEditor.tabCrop': 'חיתוך',
    'imageEditor.tabAdjust': 'כיוון',
    'imageEditor.tabFilter': 'פילטר',
    'imageEditor.aspectRatio': 'יחס גובה-רוחב',
    'imageEditor.transform': 'טרנספורמציה',
    'imageEditor.resetCrop': 'אפס חיתוך',
    'imageEditor.brightness': 'בהירות',
    'imageEditor.contrast': 'ניגודיות',
    'imageEditor.saturation': 'רוויה',
    'imageEditor.temperature': 'טמפ׳',
    'imageEditor.resetAll': 'אפס הכל',
    'imageEditor.undo': 'בטל',
    'imageEditor.redo': 'בצע שוב',
    'imageEditor.compare': 'החזק להשוואה',
    'imageEditor.filterOriginal': 'מקורי',
    'imageEditor.filterEnhanced': 'משופר',
    'imageEditor.filterVivid': 'חי',
    'imageEditor.filterBW': 'שחור-לבן',
    'imageEditor.filterVintage': 'וינטג׳',
    'imageEditor.filterCool': 'קריר',

    // --- Error Boundary ---
    'error.title': 'שגיאת מערכת',
    'error.message': 'משהו השתבש. הבעיה נרשמה ואנו נטפל בה.',
    'error.returnHome': 'חזרה לדף הבית',

    // --- Common ---
    'common.cancel': 'ביטול',
    'common.result': 'תוצאה',
    'common.results': 'תוצאות',
    'common.user': 'משתמש',
    'common.users': 'משתמשים',
    'common.session': 'סשן',
    'common.sessions': 'סשנים',
    'common.recorded': 'נרשמו',
    'common.item': 'פריט',
    'common.items': 'פריטים',

    // --- Health Dashboard (component) ---
    'healthDashboard.totalItems': 'סה"כ פריטים',
    'healthDashboard.working': 'תקינים',
    'healthDashboard.recapProgress': 'התקדמות ריקאפ',
    'healthDashboard.activeRetrobright': 'רטרוברייט פעיל',
    'healthDashboard.totalLinks': 'סה"כ קישורים',
    'healthDashboard.conditionBreakdown': 'פירוט מצבים',
    'healthDashboard.urgentAlerts': 'התראות דחופות',

    // --- User Guide ---
    'guide.title': 'מדריך למשתמש',
    'guide.subtitle': 'SiliconVault הוא מנהל מלאי לאספנים. מחשבי רטרו, מצלמות וינטג\', שעונים, ציוד Hi-Fi — ארגן, עקוב ושמר את האוסף שלך בכספות ייעודיות.',

    // Guide group labels
    'guide.groupGettingStarted': 'תחילת העבודה',
    'guide.groupCollection': 'האוסף שלך',
    'guide.groupItemFeatures': 'תכונות פריט',
    'guide.groupOrganization': 'ארגון ותובנות',
    'guide.groupCommunity': 'קהילה',
    'guide.groupAccount': 'חשבון וטיפים',

    'guide.gettingStarted': 'תחילת העבודה',
    'guide.step1Title': 'הרשם לחשבון',
    'guide.step1Desc': ' — הירשם עם אימייל וסיסמה, או לחץ על "המשך עם Google" כדי להשתמש בחשבון Google שלך. אם תיכנס עם Google באמצעות אימייל שכבר קיים במערכת, החשבונות יקושרו אוטומטית.',
    'guide.step2Title': 'הוסף את הפריט הראשון',
    'guide.step2Desc': ' - לחץ על "הוסף פריט" בסרגל הצד ומלא את הפרטים: שם, קטגוריה, פלטפורמה, מצב, מטבע ועוד.',
    'guide.step3Title': 'העלה תמונה',
    'guide.step3Desc': ' - בכל עמוד פרטי פריט, העלה תמונה והשתמש בעורך המובנה לחיתוך, סיבוב, זום והיפוך.',
    'guide.step4Title': 'עיין וחפש',
    'guide.step4Desc': ' - השתמש בעמוד המלאי לסינון לפי קטגוריה, פלטפורמה או מצב. עבור בין תצוגת רשת לתצוגת טבלה.',
    'guide.inventoryManagement': 'ניהול מלאי',
    'guide.onThisPage': 'בעמוד זה',
    'guide.tocWebVsDesktop': 'אינטרנט מול שולחן עבודה',
    'guide.addingItemsTitle': 'הוספת פריטים',
    'guide.addingItemsDesc': 'כל פריט כולל שם, קטגוריה, פלטפורמה, מצב, כמות, תיאור אופציונלי, תאריך רכישה, מחיר רכישה ומטבע. כל המשתמשים יכולים ליצור פריטים. פריטים שיצרת גלויים רק לך - מנהלים יכולים להפעיל "הצג את כל המשתמשים" כדי לראות את האוסף המלא.',
    'guide.categoriesTitle': 'קטגוריות',
    'guide.categoriesDesc': 'לכל סוג כספת יש סט קטגוריות משלו המותאם לאוסף. לדוגמה, כספת מחשבי רטרו כוללת מחשב, ציוד היקפי, תוכנה ותיעוד, בעוד כספת שעונים כוללת שעון שמלה, צלילה, כרונוגרף ועוד.',
    'guide.platformsTitle': 'פלטפורמות',
    'guide.platformsDesc': 'הפלטפורמות ספציפיות לכל סוג כספת. מחשבי רטרו כולל Commodore, Atari, Amiga, Apple ועוד. מצלמות וינטג\' כולל Nikon, Canon, Leica, Hasselblad. שעונים כולל Rolex, Omega, Seiko ועוד.',
    'guide.conditionsTitle': 'דרגות מצב',
    'guide.condMint': 'מנטה',
    'guide.condMintDesc': ' - כמו חדש, באריזה מקורית',
    'guide.condExcellent': 'מצוין',
    'guide.condExcellentDesc': ' - בלאי מינימלי, תקין לחלוטין',
    'guide.condGood': 'טוב',
    'guide.condGoodDesc': ' - בלאי קל, תקין לחלוטין',
    'guide.condFair': 'סביר',
    'guide.condFairDesc': ' - בלאי ניכר, תקין',
    'guide.condPoor': 'גרוע',
    'guide.condPoorDesc': ' - בלאי כבד, עלולות להיות תקלות',
    'guide.condParts': 'חלקים',
    'guide.condPartsDesc': ' - לחלקי חילוף או תיקון בלבד',
    'guide.currencyTitle': 'מטבע',
    'guide.currencyDesc': 'לכל פריט יכול להיות מטבע רכישה משלו. מטבעות נתמכים: USD, EUR, GBP, ILS, SEK, JPY, AUD, CAD, CHF. ברירת מחדל: USD.',
    'guide.customFieldsTitle': 'שדות מותאמים אישית',
    'guide.customFieldsDesc': 'הוסף עד 10 זוגות מפתח-ערך מותאמים אישית לכל פריט כדי לעקוב אחרי כל פרט שלא מתאים לשדות המובנים — מספרים סידוריים, הערות מודיפיקציה, מותגי קבלים, כל מה שהאוסף שלך צריך.',
    'guide.peripheralLinks': 'חיבורי ציוד היקפי',
    'guide.peripheralLinksDesc': 'חבר פריטים קשורים כדי למפות את ההתקנה שלך. לדוגמה, חבר כונן תקליטונים למחשב, עדשה לגוף מצלמה, או רצועה לשעון.',
    'guide.linkTypes': 'סוגי חיבור',
    'guide.linkTypesDesc': ' - ציוד היקפי, הרחבה, אחסון, כבל, חשמל, אחר',
    'guide.linkBidirectional': 'דו-כיווני',
    'guide.linkBidirectionalDesc': ' - חיבורים מופיעים גם בעמוד המארח וגם בעמוד הציוד ההיקפי',
    'guide.linkDeleteWarnings': 'אזהרות מחיקה',
    'guide.linkDeleteWarningsDesc': ' - מחיקת פריט עם חיבורים מציגה אזהרה עם רשימת כל הפריטים המחוברים',
    'guide.linkPlugIn': 'חבר',
    'guide.linkPlugInDesc': ' - השתמש בכפתור "חבר" בכל עמוד פרטי פריט כדי לחפש ולחבר פריט אחר',
    'guide.recapStatus': 'סטטוס ריקאפ (מפת קבלים)',
    'guide.recapStatusShort': 'סטטוס ריקאפ',
    'guide.recapDesc': 'עקוב אחרי התקדמות החלפת קבלים לכל פריט. הוסף קבלים לפי מזהה (כגון C1, C47) עם ערך, מתח וסוג. שנה סטטוס של כל קבל בשורה. שימושי בעיקר למחשבי רטרו וציוד אודיו וינטג\'י.',
    'guide.recapStatuses': 'סטטוסים',
    'guide.recapStatusesDesc': ' - מקורי (כתום), הוחלף (ירוק), דולף (אדום), הוסר, לא רלוונטי',
    'guide.recapProgress': 'סרגל התקדמות',
    'guide.recapProgressDesc': ' - מציג את אחוז הקבלים הרלוונטיים שהוחלפו',
    'guide.recapSchematic': 'העלאת סכמה',
    'guide.recapSchematicDesc': ' - צרף תמונת לוח או קובץ PDF כהפניה דרך ה-API',
    'guide.retrobrightTracker': 'מעקב רטרוברייט',
    'guide.retrobrightDesc': 'עקוב אחרי פרויקטי הלבנה באולטרה-סגול עם טיימר סשנים מובנה. צור פרויקט, הגדר מספר שעות יעד, ואז התחל ועצור סשנים מתוזמנים. המעקב צובר שעות לאורך כל הסשנים.',
    'guide.retroProjectStatuses': 'סטטוסי פרויקט',
    'guide.retroProjectStatusesDesc': ' - מתוכנן, בביצוע, מתייבש, הושלם, בוטל',
    'guide.retroSessionTimer': 'טיימר סשן',
    'guide.retroSessionTimerDesc': ' - התחל/עצור עם חישוב משך אוטומטי',
    'guide.retroPhotos': 'תמונות לפני/אחרי',
    'guide.retroPhotosDesc': ' - העלה תמונות השוואה דרך ה-API',
    'guide.retroGlow': 'זוהר UV',
    'guide.retroGlowDesc': ' - סשנים פעילים מציגים מחוון זוהר סגול',
    // Community
    'guide.community': 'קהילה',
    'guide.communityDesc': 'SiliconVault כולל שכבה קהילתית שבה אספנים יכולים להציג פריטים, לנהל רשימות מבוקשים, לשלוח הצעות החלפה או רכישה ולגלות אוספים של אספנים אחרים.',

    'guide.showroom': 'תצוגה',
    'guide.showroomDesc': 'התצוגה מציגה פריטים שמשתמשים בחרו לשתף בפומבי. עיין בפריטים מוצגים מכל הקהילה, מסוננים לפי קטגוריה, פלטפורמה או מצב.',
    'guide.showroomListings': 'סטטוסי רישום',
    'guide.showroomListingsDesc': ' - אישי (פרטי), להחלפה, או למכירה - מוגדר לכל פריט מעמוד פרטי הפריט',
    'guide.showroomPrice': 'מחיר מבוקש',
    'guide.showroomPriceDesc': ' - פריטים המפורסמים למכירה יכולים לכלול מחיר מבוקש הגלוי למשתמשים אחרים',

    'guide.publicProfiles': 'פרופילים ציבוריים',
    'guide.publicProfilesDesc': 'כל משתמש יכול להגדיר פרופיל ציבורי הגלוי לקהילה. התאם אישית מההגדרות:',
    'guide.profileAvatar': 'תמונת פרופיל',
    'guide.profileAvatarDesc': ' - העלה תמונת פרופיל',
    'guide.profileBio': 'אודות',
    'guide.profileBioDesc': ' - תיאור קצר עליך או על האוסף שלך',
    'guide.profileLocation': 'מיקום',
    'guide.profileLocationDesc': ' - העיר או האזור שלך, מוצג בפרופיל הציבורי',
    'guide.profileSlug': 'כתובת פרופיל',
    'guide.profileSlugDesc': ' - כתובת מותאמת אישית לקישור פרופיל שניתן לשתף (למשל, /profile/retro-collector)',

    'guide.wantedList': 'רשימת מבוקשים',
    'guide.wantedListDesc': 'נהל רשימה של פריטים שאתה מחפש. אספנים אחרים יכולים לראות את הפריטים המבוקשים הציבוריים שלך ולפנות אליך עם הצעות.',
    'guide.wantedVisibility': 'נראות',
    'guide.wantedVisibilityDesc': ' - כל פריט מבוקש יכול להיות ציבורי (גלוי בפרופיל שלך) או פרטי',
    'guide.wantedCondition': 'מצב מינימלי',
    'guide.wantedConditionDesc': ' - ניתן לציין את דרגת המצב המינימלית המקובלת',

    'guide.offersTrading': 'הצעות ומסחר',
    'guide.offersTradingDesc': 'שלח וקבל הצעות החלפה או רכישה עם אספנים אחרים ישירות בתוך SiliconVault.',
    'guide.offerCreate': 'יצירת הצעה',
    'guide.offerCreateDesc': ' - בחר פריטים להצעה, פריטים לבקש, הוסף מרכיב מזומן אופציונלי והודעה',
    'guide.offerFlow': 'מהלך הצעה',
    'guide.offerFlowDesc': ' - ממתינה, אושרה, נדחתה, או בוטלה - שני הצדדים יכולים לעקוב אחר הסטטוס',
    'guide.offerInbox': 'תיבת הצעות',
    'guide.offerInboxDesc': ' - סנן לפי שהתקבלו, שנשלחו, או הכל - עם מסנני סטטוס להצעות ממתינות',

    'guide.catalogSharing': 'שיתוף קטלוג ציבורי',
    'guide.catalogSharingDesc': 'שתף את האוסף שלך עם כל אחד — מבקרים יכולים לעיין בקטלוג שלך ללא הרשמה. הגדר כתובת פרופיל בהגדרות כדי לאפשר שיתוף. אם יש לך מספר כספות, תוכל לשלוט אילו מהן גלויות בפרופיל הציבורי שלך.',
    'guide.sharingSlug': 'כתובת פרופיל',
    'guide.sharingSlugDesc': ' — הגדר כינוי מותאם (למשל /profile/retro-fan) בהגדרות → פרופיל ציבורי כדי להפוך את הקטלוג שלך לנגיש לציבור',
    'guide.sharingPublicAccess': 'גישה אנונימית',
    'guide.sharingPublicAccessDesc': ' — כל מי שיש לו את הקישור שלך יכול לצפות בפריטים המוצגים, ברשימות להחלפה/למכירה ובפרופיל מבלי ליצור חשבון',
    'guide.sharingModal': 'חלון שיתוף',
    'guide.sharingModalDesc': ' — לחץ על "שתף קטלוג" בפרופיל שלך או בהגדרות כדי לפתוח דיאלוג שיתוף עם הכתובת, קוד QR וכפתורי רשתות חברתיות',
    'guide.sharingSocial': 'שיתוף ברשתות חברתיות',
    'guide.sharingSocialDesc': ' — שיתוף בלחיצה אחת ל-X (טוויטר), פייסבוק, וואטסאפ וטלגרם; גיליון שיתוף מקורי במכשירים ניידים',
    'guide.sharingAnalytics': 'ניתוח קטלוג',
    'guide.sharingAnalyticsDesc': ' — צפה בסך צפיות בקטלוג, פירוט שבועי/חודשי ומפנים מובילים בהגדרות → פרופיל ציבורי',
    'guide.sharingMilestones': 'אבני דרך בצפיות',
    'guide.sharingMilestonesDesc': ' — קבל התראות כאשר הקטלוג שלך מגיע ל-10, 50, 100, 500 ו-1,000 צפיות',
    'guide.sharingVaultVisibility': 'נראות לפי כספת',
    'guide.sharingVaultVisibilityDesc': ' — בהגדרות → פרופיל ציבורי → כספות משותפות, בחר אילו כספות יופיעו בקטלוג הציבורי שלך. כספות שלא סומנו והפריטים שבהן מוסתרים ממבקרים',
    'guide.sharingVaultTabs': 'לשוניות כספות',
    'guide.sharingVaultTabsDesc': ' — כאשר משתפים שתי כספות או יותר, מבקרים רואים שורת לשוניות בפרופיל לסינון לפי סוג כספת (למשל "הכל / מחשבי רטרו / שעונים")',
    'guide.sharingOg': 'תצוגות מקדימות חברתיות',
    'guide.sharingOgDesc': ' — קישורים משותפים מציגים כרטיסי תצוגה מקדימה עשירים (כותרת, תיאור, אווטאר) בטוויטר, פייסבוק, סלאק, דיסקורד ופלטפורמות נוספות',

    'guide.favorites': 'מועדפים',
    'guide.favoritesDesc': 'סמן כל פריט מוצג כמועדף לסימניה. ספירת המועדפים גלויה בכל פריט, ובעל הפריט מקבל התראה כאשר מישהו מסמן את הפריט שלו כמועדף.',

    'guide.notifications': 'התראות',
    'guide.notificationsDesc': 'סמל הפעמון בכותרת מציג התראות שלא נקראו. סוגי ההתראות כוללים:',
    'guide.notifOffer': 'הצעה התקבלה',
    'guide.notifOfferDesc': ' - כאשר מישהו שולח לך הצעת החלפה או רכישה',
    'guide.notifAccepted': 'הצעה אושרה/נדחתה',
    'guide.notifAcceptedDesc': ' - כאשר הצד השני מגיב להצעה שלך',
    'guide.notifWanted': 'התאמה למבוקש',
    'guide.notifWantedDesc': ' - כאשר פריט חדש בתצוגה תואם לאחד מהפריטים המבוקשים שלך',
    'guide.notifFavorite': 'פריט סומן כמועדף',
    'guide.notifFavoriteDesc': ' - כאשר מישהו מסמן את אחד מהפריטים המוצגים שלך כמועדף',
    'guide.notifProfile': 'הפרופיל נצפה',
    'guide.notifProfileDesc': ' - כאשר משתמש אחר מבקר בפרופיל הציבורי שלך',
    'guide.notifMilestone': 'אבן דרך בקטלוג',
    'guide.notifMilestoneDesc': ' - כאשר הקטלוג הציבורי שלך מגיע לאבן דרך בצפיות (10, 50, 100, 500, 1,000)',

    'guide.theLibrary': 'הספריה',
    'guide.libraryDesc': 'מאגר קבצים למדריכים, תמונות דיסק, קבצי ROM, סכמות ועוד. העלה קבצים וקשר אותם אופציונלית לפריטי מלאי ספציפיים.',
    'guide.fileTypes': 'סוגי קבצים',
    'guide.fileTypesDesc': ' - מדריכי PDF, תמונות דיסק .d64/.tap/.adf/.dsk, ROMים, קושחה, סכמות',
    'guide.validation': 'ולידציה',
    'guide.validationDesc': ' - בדיקות סוג MIME וסיומת לכל סוג קובץ, מקסימום 50MB',
    'guide.sha256': 'בדיקת SHA-256',
    'guide.sha256Desc': ' - מחושבת אוטומטית בהעלאה לאימות שלמות',
    'guide.filtering': 'סינון',
    'guide.filteringDesc': ' - עיין לפי סוג קובץ, פלטפורמה, או חפש לפי שם',
    'guide.itemAssociation': 'שיוך לפריט',
    'guide.itemAssociationDesc': ' - קבצים משויכים מופיעים בעמוד פרטי הפריט',
    'guide.maintenancePulse': 'דופק תחזוקה (לוח בריאות)',
    'guide.maintenancePulseShort': 'דופק תחזוקה',
    'guide.maintenancePulseDesc': 'מבט-על על בריאות האוסף שלך. מאגד נתונים ממצב מלאי, מפות קבלים, פרויקטי רטרוברייט, חיבורי ציוד היקפי והתראות תחזוקה ללוח בקרה אחד.',
    'guide.healthStats': 'סטטיסטיקות',
    'guide.healthStatsDesc': ' - סה"כ פריטים, אחוז תקינים, התקדמות ריקאפ, פרויקטי רטרוברייט פעילים, מספר קישורים',
    'guide.healthCondition': 'פירוט מצבים',
    'guide.healthConditionDesc': ' - פריטים מקובצים לפי דרגת מצב',
    'guide.healthUrgent': 'התראות דחופות',
    'guide.healthUrgentDesc': ' - רשימה מתועדפת של התראות תחזוקה שלא טופלו',
    'guide.healthAutoAlerts': 'התראות אוטומטיות',
    'guide.healthAutoAlertsDesc': ' - אזהרות ספציפיות לכספת שנוצרות אוטומטית (כגון "הסר סוללת שעון" עבור Amiga, "שירות באיחור" עבור שעונים, "נדרש CLA" עבור מצלמות)',
    'guide.healthSeverities': 'רמות חומרה',
    'guide.healthSeveritiesDesc': ' - קריטי, גבוה, בינוני, נמוך - עם מחוונים צבעוניים',
    'guide.browsingFiltering': 'עיון וסינון',
    'guide.searchFiltersTitle': 'חיפוש ומסננים',
    'guide.searchFiltersDesc': 'השתמש בשורת החיפוש כדי למצוא פריטים לפי שם. שלב עם מסנני קטגוריה, פלטפורמה ומצב לצמצום תוצאות. המסננים חלים גם על ייצוא.',
    'guide.viewsSortingTitle': 'תצוגות ומיון',
    'guide.viewsSortingDesc': 'עבור בין תצוגת רשת (כרטיסים עם תמונות) לתצוגת טבלה (עמודות ניתנות למיון). לחץ על כל כותרת עמודה בתצוגת טבלה למיון עולה או יורד.',
    'guide.paginationTitle': 'עימוד',
    'guide.paginationDesc': 'התוצאות מחולקות ל-20 פריטים בעמוד. השתמש בכפתורי הקודם/הבא לניווט. העמוד מתאפס ל-1 כאשר המסננים משתנים.',
    'guide.imageEditor': 'עורך תמונות',
    'guide.imageEditorDesc': 'העלה תמונות JPEG, PNG או WebP — כל גודל, מוקטנות אוטומטית. העורך המובנה מאפשר לך לכוונן תמונות לפני שמירה:',
    'guide.editorCrop': 'חיתוך',
    'guide.editorCropDesc': ' - חופשי או יחסי מידה קבועים (1:1, 4:3, 16:9)',
    'guide.editorZoom': 'זום',
    'guide.editorZoomDesc': ' - 1x עד 3x עם מחוון דיוק',
    'guide.editorRotate': 'סיבוב',
    'guide.editorRotateDesc': ' - 0-360\u00B0 עם כפתורי 90\u00B0 מהירים',
    'guide.editorFlip': 'היפוך',
    'guide.editorFlipDesc': ' - שיקוף אופקי או אנכי',
    'guide.editorReset': 'איפוס',
    'guide.editorResetDesc': ' - החזר את כל העריכות למקור',
    'guide.batchAdd': 'הוספה מרוכזת',
    'guide.batchAddDesc': 'הוסיפו מספר פריטים בבת אחת על ידי גרירה או בחירה של מספר תמונות. כל תמונה מנותחת על ידי AI (אם מוגדר) ומוצגת ככרטיס עם שדות טופס ממולאים מראש.',
    'guide.batchDrop': 'גרירה או בחירה — ',
    'guide.batchDropDesc': 'גררו מספר תמונות לאזור הגרירה, או לחצו לבחירת קבצים. נתמכים JPEG, PNG ו-WebP.',
    'guide.batchAi': 'ניתוח אוטומטי — ',
    'guide.batchAiDesc': 'התמונות מנותחות במקביל (עד 3 בו-זמנית) באמצעות ספק ה-AI המוגדר. אם AI לא מוגדר, הפריטים נוספים עם טפסים ריקים למילוי ידני.',
    'guide.batchReview': 'סקירה ועריכה — ',
    'guide.batchReviewDesc': 'כל פריט מופיע ככרטיס מתקפל. הרחיבו כל כרטיס כדי לערוך את השם, הקטגוריה, הפלטפורמה, המצב ושאר השדות לפני השמירה.',
    'guide.batchProgress': 'מעקב התקדמות — ',
    'guide.batchProgressDesc': 'באנר התקדמות מציג כמה פריטים נשמרו. ניתן לנווט לדף אחר בזמן שהשמירה ממשיכה ברקע.',
    'guide.batchRetry': 'טיפול בשגיאות — ',
    'guide.batchRetryDesc': 'אם פריט נכשל בניתוח או בשמירה, מוצג תג שגיאה עם כפתור ניסיון חוזר. פריטים שנשמרו בהצלחה ניתנים לניקוי מהרשימה.',

    'guide.aiImageAnalysis': 'זיהוי תמונות בינה מלאכותית',
    'guide.aiImageAnalysisDesc': 'SiliconVault יכול לזהות פריטים מתמונות באמצעות בינה מלאכותית — בין אם זה מחשב וינטג\'י, מצלמת פילם, שעון מכני או מגבר. השתמש באפשרות "סריקה עם AI" בעת הוספת פריט חדש כדי למלא אוטומטית את שדות הטופס (שם, קטגוריה, פלטפורמה, מצב ועוד).',
    'guide.aiByokTitle': 'הבא מפתח משלך',
    'guide.aiByokDesc': 'ניתן להשתמש בזיהוי AI בחינם על ידי סיפוק מפתח API משלך. עבור להגדרות → הגדרות AI כדי להזין את הפרטים שלך. ספקים נתמכים:',
    'guide.aiProviderOpenai': 'OpenAI',
    'guide.aiProviderOpenaiDesc': ' — השתמש במפתח ה-API שלך מ-OpenAI (GPT-4o)',
    'guide.aiProviderAzure': 'Azure OpenAI',
    'guide.aiProviderAzureDesc': ' — השתמש בנקודת הקצה של Azure OpenAI, שם הפריסה ומפתח ה-API',
    'guide.aiProviderGemini': 'Google Gemini',
    'guide.aiProviderGeminiDesc': ' — השתמש במפתח ה-API שלך מ-Gemini (ברירת מחדל: Gemini 2.5 Flash)',
    'guide.aiProviderCustom': 'מותאם אישית',
    'guide.aiProviderCustomDesc': ' — כל נקודת קצה תואמת OpenAI (למשל מודלים מקומיים, ספקים צד שלישי)',
    'guide.aiProTitle': 'תוכנית Pro',
    'guide.aiProDesc': 'לא רוצה לנהל מפתח API משלך? הירשם ל-SiliconVault Pro לזיהוי AI מתארח על בסיס Google Gemini — 500 ניתוחים בחודש, ללא הגדרות נדרשות. שדרג מההגדרות.',
    'guide.aiCostNote': 'עם מפתח משלך, השימוש ב-API מחויב על ידי הספק שלך. כל סריקה עולה בדרך כלל שבריר של סנט. מנויי Pro מקבלים 500 ניתוחים בחודש.',
    'guide.export': 'גיבוי נתונים וייצוא',
    'guide.exportDesc': 'SiliconVault מציע מספר דרכים להגן ולייצא את הנתונים שלך, בהתאם לשימוש באפליקציית הווב או הדסקטופ.',
    'guide.exportFormatsTitle': 'פורמטי ייצוא (ווב ודסקטופ)',
    'guide.exportCsv': 'CSV — ',
    'guide.exportCsvDesc': 'פורמט ידידותי לגיליונות אלקטרוניים. מצוין לייבוא ל-Excel, Google Sheets, או כלי מלאי אחרים.',
    'guide.exportJson': 'JSON — ',
    'guide.exportJsonDesc': 'פורמט נתונים מובנה עם חותמות זמן. אידיאלי לגישה תכנותית, ארכיון, או העברה בין מערכות.',
    'guide.exportPdf': 'קטלוג PDF — ',
    'guide.exportPdfDesc': 'קטלוג להדפסה עם תמונות. בחר מתוך שלוש פריסות אריחים (גדול, קומפקטי, צפוף). מושלם לתיעוד ביטוח, שיתוף, או הדפסה.',
    'guide.exportFilters': 'ייצוא מסונן — ',
    'guide.exportFiltersDesc': 'הייצוא מכבד את בחירות החיפוש והסינון הנוכחיות, כך שתוכל לייצא תת-קבוצה של האוסף. הייצוא מותאם לכספת הפעילה.',
    'guide.exportDesktopTitle': 'גיבוי ושחזור מסד נתונים (אפליקציית דסקטופ)',
    'guide.exportDesktopDesc': 'אפליקציית הדסקטופ שומרת את כל הנתונים במסד נתונים מקומי SQLite. תכונת הגיבוי והשחזור בהגדרות מספקת הגנה מלאה ברמת מסד הנתונים:',
    'guide.exportDesktopAuto': 'גיבויים אוטומטיים לפני עדכון — ',
    'guide.exportDesktopAutoDesc': 'כשהאפליקציה מזהה שינויים ממתינים במסד הנתונים לאחר עדכון, היא יוצרת גיבוי בשם ייחודי לפני החלתם. אלו לעולם לא נדרסים — כל עדכון מייצר תמונת מצב משלו.',
    'guide.exportDesktopManual': 'גיבויים ידניים — ',
    'guide.exportDesktopManualDesc': 'לחץ "צור גיבוי" בהגדרות → גיבוי ושחזור כדי ליצור תמונת מצב של מסד הנתונים בכל עת.',
    'guide.exportDesktopRestore': 'שחזור — ',
    'guide.exportDesktopRestoreDesc': 'בחר גיבוי כלשהו ולחץ שחזר. תמונת מצב בטיחותית של מסד הנתונים הנוכחי נוצרת אוטומטית לפני השחזור. יש להפעיל מחדש את האפליקציה לאחר השחזור.',
    'guide.exportDesktopSchema': 'אזהרות סכמה — ',
    'guide.exportDesktopSchemaDesc': 'בעת שחזור גיבוי מגרסה ישנה יותר של האפליקציה, תוצג אזהרה. שינויי מסד נתונים חדשים יותר יוחלו מחדש אוטומטית בהפעלה הבאה.',
    'guide.exportDesktopFolder': 'פתח תיקייה — ',
    'guide.exportDesktopFolderDesc': 'חושף את תיקיית הגיבויים במנהל הקבצים לגישה ידנית.',
    'guide.exportWebTitle': 'גיבוי בווב',
    'guide.exportWebDesc': 'אפליקציית הווב שומרת נתונים בענן, כך שאין צורך לדאוג לגיבויים מקומיים. עם זאת, ניתן לייצא את הנתונים בכל עת כ-CSV, JSON או PDF לארכיון מקומי או לשמירת עותק מקומי של האוסף.',
    // Plans & Pricing
    'guide.plans': 'תוכניות ומחירים',
    'guide.plansDesc': 'SiliconVault מציע תוכנית חינמית ומנוי Pro. ניתן לצפות בתוכנית הנוכחית ולשדרג מסרגל הצד או מדף השדרוג.',
    'guide.plansFreeTitle': 'חינם',
    'guide.plansFree1': 'עד 100 פריטים באוסף',
    'guide.plansFree2': 'סוג כספת אחד',
    'guide.plansFree3': '5 פריטים בתצוגה הקהילתית',
    'guide.plansFree4': 'ייצוא CSV ו-JSON',
    'guide.plansFree5': '5 סריקות AI בחודש + ללא הגבלה עם מפתח API שלך',
    'guide.plansProTitle': 'Pro — $5/חודש או $40/שנה',
    'guide.plansPro1': 'פריטים ללא הגבלה',
    'guide.plansPro2': 'כל סוגי הכספות',
    'guide.plansPro3': 'פריטי תצוגה ללא הגבלה',
    'guide.plansPro4': '500 ניתוחי AI בחודש (מנוהל) + ללא הגבלה עם מפתח שלך',
    'guide.plansPro5': 'ייצוא CSV, JSON ו-PDF',
    'guide.plansDesktopTitle': 'דסקטופ — $50 חד-פעמי',
    'guide.plansDesktop1': 'מקומי לחלוטין — ללא אינטרנט או חשבון',
    'guide.plansDesktop2': 'פריטים מקומיים ללא הגבלה עם אחסון SQLite',
    'guide.plansDesktop3': 'ניתוח AI עם מפתח API שלך',
    'guide.plansDesktop4': 'התקנה על Windows, Mac ו-Linux',
    'guide.plansUpgrade': 'לשדרוג ל-Pro, לחץ על תג התוכנית בסרגל הצד או בקר בדף השדרוג. ניתן לבחור בין חיוב חודשי לשנתי בתשלום.',
    'guide.plansUpgradePre': 'למידע נוסף על אפליקציית הדסקטופ, בקר בדף ',
    'guide.plansUpgradeLink': 'ההורדה',
    'guide.plansUpgradePost': '.',

    'guide.rolesPermissions': 'תפקידים והרשאות',
    'guide.adminRole': 'מנהל',
    'guide.userRole': 'משתמש',
    'guide.adminPerm1': 'רואה את הפריטים שלו כברירת מחדל, מפעיל "הצג את כל המשתמשים" כדי לראות הכל',
    'guide.adminPerm2': 'יצירה, עריכה ומחיקה של כל פריט',
    'guide.adminPerm3': 'העלאה ועריכה של תמונות בכל פריט',
    'guide.adminPerm5': 'גישה לממשק הניהול',
    'guide.adminPerm6': 'הוספה, הסרה ושינוי תפקידי משתמשים',
    'guide.userPerm1': 'רואה רק את הפריטים שלו במלאי, בלוח הבקרה ובייצוא',
    'guide.userPerm2': 'יצירת פריטים חדשים',
    'guide.userPerm3': 'עריכה ומחיקה של הפריטים שלו בלבד',
    'guide.userPerm4': 'העלאה ועריכה של תמונות בפריטים שלו',
    'guide.userPerm5': 'העלאת קבצים לספריה',
    'guide.userPerm6': 'מעקב אחרי ריקאפ קבלים, פרויקטי רטרוברייט ומחירים בפריטים שלו',
    'guide.userPerm7': 'ייצוא נתוני מלאי שלו',
    'guide.adminPanel': 'ממשק ניהול',
    'guide.adminPanelDesc': 'מנהלים יכולים לגשת לממשק הניהול מסרגל הצד. משם ניתן:',
    'guide.adminAction1': 'צפייה בכל המשתמשים הרשומים עם תפקידיהם ותאריכי הצטרפותם',
    'guide.adminAction2': 'הוספת משתמשים חדשים עם תפקיד מוגדר וסיסמה זמנית',
    'guide.adminAction3': 'שינוי תפקיד של כל משתמש בין מנהל למשתמש',
    'guide.adminAction4': 'הסרת משתמשים (לא ניתן להסיר את עצמך)',
    'guide.tips': 'טיפים',
    'guide.tip1pre': 'לחץ ',
    'guide.tip1key': 'Esc',
    'guide.tip1post': ' לסגירת כל חלון קופץ או דיאלוג',
    'guide.tip2': 'השתמש במסנן המצב כדי למצוא במהירות פריטים הזקוקים לתיקון',
    'guide.tip3': 'ייצא רשימה מסוננת כדי לשתף תת-קבוצה ספציפית של האוסף שלך',
    'guide.tip4': 'לוח הבקרה מציג את 8 הפריטים שנוספו לאחרונה במבט חטוף',
    'guide.tip5': 'חבר ציוד היקפי למכונות מארחות כדי לראות את כל ההגדרה שלך ממוגנת',
    'guide.tip6': 'בדוק את לוח התחזוקה באופן קבוע לאיתור אזהרות תחזוקה אוטומטיות',
    'guide.tip7': 'השתמש במעקב ריקאפ כדי להישאר מעודכן בהחלפת קבלים לאורך האוסף שלך',
    'guide.tip8': 'סמן פריטים כ"להחלפה" או "למכירה" כדי שיופיעו בתצוגה וימשכו הצעות',
    'guide.tip9': 'הוסף פריטים לרשימת המבוקשים שלך כדי שאספנים אחרים יוכלו להתאים אותך עם מה שיש להם',
    'guide.tip10': 'נרשמת עם Google? החשבון שלך מקושר אוטומטית — אין צורך בסיסמה נפרדת',
    'guide.tip11': 'השתמש בדף הסטטיסטיקות כדי להמחיש את האוסף שלך לפי פלטפורמה, מצב וערך',
    'guide.tip12': 'בדוק את פיד הפעילות כדי לראות מה אספנים אחרים מפרסמים, מחליפים ומציגים',
    'guide.tip13': 'שלח הודעות ישירות לאספנים אחרים מהפרופיל שלהם או מדף פרטי הפריט',
    'guide.tip14': 'הפעל זיהוי כפילויות כדי למצוא ולמזג פריטים דומים באוסף שלך',
    'guide.tip15': 'צור סטים מתוך תבניות כדי לעקוב אחר ההתקדמות לקראת אוסף שלם',
    'guide.tip16': 'השתמש בגיבוי ושחזור בהגדרות כדי ליצור תמונות מצב של הנתונים לפני שינויים גדולים',

    // --- Guide: Multi-Vault ---
    'guide.multiVault': 'ריבוי כספות',
    'guide.multiVaultDesc': 'ארגן את האוסף שלך בכספות נפרדות, כל אחת מותאמת לקטגוריית אספנות ספציפית. החלף בין כספות באמצעות בורר הכספות בסרגל הניווט העליון.',
    'guide.vaultTypes': 'סוגי כספות — ',
    'guide.vaultTypesDesc': 'בחר מתוך מחשבים רטרו, אודיו רטרו / Hi-Fi, מצלמות וינטג\', ושעונים. כל סוג מספק קטגוריות, מותגים ורשימות פלטפורמות מתמחות.',
    'guide.vaultSwitcher': 'מחליף כספות — ',
    'guide.vaultSwitcherDesc': 'השתמש בתפריט הנפתח בכותרת כדי לעבור בין כספות. המלאי, הסטים, הסטטיסטיקות ורשימת המבוקשים מסוננים לפי הכספת הפעילה.',
    'guide.vaultCreate': 'יצירת כספות — ',
    'guide.vaultCreateDesc': 'צור כספות חדשות מדף הכספות. לכל כספת יש שם וסוג שקובע את השדות המתמחים שלה.',
    'guide.vaultScoping': 'סינון נתונים — ',
    'guide.vaultScopingDesc': 'פריטים, סטים, רשימות מבוקשים, קבצי ספרייה וסטטיסטיקות מסוננים לפי הכספת הפעילה. גם הייצוא מכבד את היקף הכספת.',


    // --- Stats Dashboard ---
    'guide.statsDashboard': 'לוח סטטיסטיקות',
    'guide.statsDashboardDesc': 'דף הסטטיסטיקות מספק ניתוח ויזואלי של האוסף שלך עם גרפים אינטראקטיביים.',
    'guide.statsSummary': 'כרטיסי סיכום — ',
    'guide.statsSummaryDesc': 'סה"כ פריטים, ערך כולל, פלטפורמות ייחודיות וקטגוריות ייחודיות במבט אחד.',
    'guide.statsPlatformChart': 'התפלגות פלטפורמות — ',
    'guide.statsPlatformChartDesc': 'גרף טבעת המציג כמה פריטים יש לך בכל פלטפורמה.',
    'guide.statsConditionChart': 'פילוח מצב — ',
    'guide.statsConditionChartDesc': 'גרף עמודות של מצבי פריטים ממנט ועד חלקים.',
    'guide.statsTimelineChart': 'ציר זמן רכישות — ',
    'guide.statsTimelineChartDesc': 'גרף שטח המציג פריטים שנוספו ב-12 החודשים האחרונים.',
    'guide.statsValueChart': 'ערך לפי קטגוריה — ',
    'guide.statsValueChartDesc': 'גרף עמודות אופקי של ערך רכישה כולל מקובץ לפי קטגוריה.',

    // --- Activity Feed ---
    'guide.activityFeed': 'פיד פעילות',
    'guide.activityFeedDesc': 'פיד קהילתי המציג אירועים אחרונים מכל האספנים.',
    'guide.activityListed': 'פריט פורסם — ',
    'guide.activityListedDesc': 'כשאספן מפרסם פריט להחלפה או למכירה.',
    'guide.activityTraded': 'עסקה הושלמה — ',
    'guide.activityTradedDesc': 'כשהצעה מתקבלת בין שני אספנים.',
    'guide.activityJoined': 'חבר הצטרף — ',
    'guide.activityJoinedDesc': 'כשאספן חדש נרשם ל-SiliconVault.',
    'guide.activityShowcased': 'פריט הוצג — ',
    'guide.activityShowcasedDesc': 'כשאספן מוסיף פריט לתצוגה.',
    'guide.activityFilters': 'סינון לפי סוג — ',
    'guide.activityFiltersDesc': 'סנן את הפיד לפי סוג אירוע כדי לראות רק מה שמעניין אותך.',

    // --- Direct Messaging ---
    'guide.directMessaging': 'הודעות ישירות',
    'guide.directMessagingDesc': 'שלח הודעות פרטיות לאספנים אחרים כדי לדון בעסקאות, לשאול שאלות או לתאם.',
    'guide.msgStartConversation': 'התחל שיחה — ',
    'guide.msgStartConversationDesc': 'לחץ על "שלח הודעה" בפרופיל של אספן או בדף פרטי הפריט.',
    'guide.msgThreads': 'שרשורי שיחה — ',
    'guide.msgThreadsDesc': 'דף ההודעות מציג את כל השיחות שלך בתצוגה מפוצלת.',
    'guide.msgUnread': 'סימוני לא נקרא — ',
    'guide.msgUnreadDesc': 'מספר ההודעות שלא נקראו מופיע בתפריט הצד ובכל שיחה.',
    'guide.msgNotifications': 'התראות — ',
    'guide.msgNotificationsDesc': 'תקבל התראה כשמישהו שולח לך הודעה חדשה.',
    'guide.msgProfileLink': 'קישורי פרופיל — ',
    'guide.msgProfileLinkDesc': 'לחץ על האווטאר או השם בכותרת השרשור כדי לבקר בפרופיל של האספן.',

    // --- Duplicate Detection ---
    'guide.duplicateDetection': 'זיהוי כפילויות',
    'guide.duplicateDetectionDesc': 'סרוק את האוסף שלך לאיתור פריטים כפולים פוטנציאליים באמצעות התאמת שמות מעורפלת.',
    'guide.dupScan': 'סריקה — ',
    'guide.dupScanDesc': 'לחץ על "סרוק כפילויות" כדי למצוא פריטים עם שמות דומים.',
    'guide.dupReview': 'סקירה זה-לצד-זה — ',
    'guide.dupReviewDesc': 'השווה כפילויות פוטנציאליות עם ציוני דמיון והחלט מה לעשות.',
    'guide.dupDismiss': 'ביטול — ',
    'guide.dupDismissDesc': 'סמן זוג כ"לא כפילות" כדי שלא יופיע שוב.',
    'guide.dupMerge': 'מיזוג — ',
    'guide.dupMergeDesc': 'שמור פריט אחד והעבר את כל הנתונים המקושרים (קישורים, קבלים, רטרוברייט, התראות, קבצים) מהשני.',

    // --- Set Completeness ---
    'guide.setCompleteness': 'סטים של אוסף',
    'guide.setCompletenessDesc': 'הגדר אוספי יעד ועקוב אחר הפריטים שברשותך לקראת השלמת סט.',
    'guide.setTemplates': 'תבניות — ',
    'guide.setTemplatesDesc': 'צור סט מתבניות מוגדרות מראש המותאמות לכל סוג כספת.',
    'guide.setCustom': 'סטים מותאמים — ',
    'guide.setCustomDesc': 'בנה סט משלך מאפס עם כל פריט שתבחר.',
    'guide.setProgress': 'מעקב התקדמות — ',
    'guide.setProgressDesc': 'כל סט מציג סרגל התקדמות עם "X מתוך Y" פריטים ברשותך.',
    'guide.setAutoMatch': 'התאמה אוטומטית — ',
    'guide.setAutoMatchDesc': 'קשר אוטומטית פריטי סט לרשומות מלאי תואמות לפי שם.',
    'guide.setManualToggle': 'החלפה ידנית — ',
    'guide.setManualToggleDesc': 'סמן פריטים בודדים כברשותך או לא בלחיצה אחת.',

    // --- Guide navigation new entries ---

    // --- Community / Trading ---
    'nav.wanted': 'מבוקשים',
    'nav.offers': 'הצעות',
    'nav.myProfile': 'הפרופיל שלי',
    'nav.shareCatalog': 'שתף קטלוג',
    'breadcrumb.wanted': 'מבוקשים',
    'breadcrumb.offers': 'הצעות',
    'breadcrumb.profile': 'פרופיל',
    'breadcrumb.offerDetail': 'פרטי הצעה',

    'community.items': 'פריטים',
    'community.showcased': 'בתצוגה',
    'community.forTrade': 'להחלפה',
    'community.forSale': 'למכירה',
    'community.filterAll': 'הכל',
    'community.filterShowcase': 'תצוגה',
    'community.filterForTrade': 'להחלפה',
    'community.filterForSale': 'למכירה',
    'community.noPublicItems': 'אין עדיין פריטים ציבוריים.',
    'community.loadingProfile': 'טוען פרופיל...',
    'community.profileNotFound': 'הפרופיל לא נמצא.',
    'community.wantedList': 'רשימת מבוקשים',
    'community.publicProfile': 'פרופיל ציבורי',
    'community.uploadAvatar': 'העלה תמונה',
    'community.removeAvatar': 'הסר',
    'community.bio': 'אודות',
    'community.bioPlaceholder': 'ספר לנו על האוסף שלך...',
    'community.location': 'מיקום',
    'community.locationPlaceholder': 'לדוגמה, תל אביב, ישראל',
    'community.profileSlug': 'כתובת פרופיל',
    'community.slugPlaceholder': 'לדוגמה, retro-collector',
    'community.profileUpdated': 'הפרופיל עודכן',
    'community.profileUpdateFailed': 'עדכון הפרופיל נכשל',
    'community.avatarUpdated': 'התמונה עודכנה',
    'community.avatarUpdateFailed': 'עדכון התמונה נכשל',
    'community.avatarRemoved': 'התמונה הוסרה',
    'community.avatarRemoveFailed': 'הסרת התמונה נכשלה',
    'community.listingStatus': 'סטטוס רישום',
    'community.statusPersonal': 'אישי',
    'community.statusForTrade': 'להחלפה',
    'community.statusForSale': 'למכירה',
    'community.askingPrice': 'מחיר מבוקש',
    'community.listingUpdated': 'הרישום עודכן',
    'community.listingUpdateFailed': 'עדכון הרישום נכשל',
    'community.addWantedItem': 'הוסף מבוקש',
    'community.editWantedItem': 'ערוך פריט מבוקש',
    'community.save': 'שמור',
    'community.add': 'הוסף',
    'community.edit': 'ערוך',
    'community.delete': 'מחק',
    'community.minCondition': 'מצב מינימלי',
    'community.anyCondition': 'כלשהו',
    'community.publiclyVisible': 'גלוי לציבור',
    'community.publiclyVisibleDesc': 'אחרים יכולים לראות פריט זה בפרופיל שלך',
    'community.private': 'פרטי',
    'community.loadingWanted': 'טוען פריטים מבוקשים...',
    'community.noWantedItems': 'אין עדיין פריטים מבוקשים',
    'community.noWantedItemsDesc': 'הוסף פריטים שאתה מחפש כדי שאספנים אחרים יוכלו למצוא אותם.',
    'community.wantedItemCreated': 'פריט מבוקש נוסף',
    'community.wantedItemCreateFailed': 'הוספת פריט מבוקש נכשלה',
    'community.wantedItemUpdated': 'פריט מבוקש עודכן',
    'community.wantedItemUpdateFailed': 'עדכון פריט מבוקש נכשל',
    'community.wantedItemDeleted': 'פריט מבוקש הוסר',
    'community.wantedItemDeleteFailed': 'הסרת פריט מבוקש נכשלה',
    'community.offers': 'הצעות',
    'community.allOffers': 'הכל',
    'community.received': 'שהתקבלו',
    'community.sent': 'שנשלחו',
    'community.allStatuses': 'כל הסטטוסים',
    'community.pendingOnly': 'ממתינות',
    'community.loadingOffers': 'טוען הצעות...',
    'community.noOffers': 'אין עדיין הצעות',
    'community.noOffersDesc': 'כאשר תשלח או תקבל הצעות החלפה או קנייה, הן יופיעו כאן.',
    'community.you': 'אתה',
    'community.offering': 'מציע',
    'community.requesting': 'מבקש',
    'community.from': 'מאת',
    'community.to': 'אל',
    'community.message': 'הודעה',
    'community.messagePlaceholder': 'הוסף הודעה להצעה שלך...',
    'community.offeredItems': 'פריטים מוצעים',
    'community.requestedItems': 'פריטים מבוקשים',
    'community.noItemsOffered': 'אין פריטים מוצעים (מזומן בלבד)',
    'community.noItemsRequested': 'אין פריטים מבוקשים',
    'community.searchItems': 'חיפוש פריטים...',
    'community.tradeOffer': 'הצעת החלפה',
    'community.cashComponent': 'מרכיב מזומן',
    'community.accept': 'אשר',
    'community.decline': 'דחה',
    'community.withdraw': 'בטל',
    'community.created': 'נוצר',
    'community.responded': 'הגיב',
    'community.offerAccepted': 'ההצעה אושרה',
    'community.offerDeclined': 'ההצעה נדחתה',
    'community.offerWithdrawn': 'ההצעה בוטלה',
    'community.offerActionFailed': 'עדכון ההצעה נכשל',
    'community.backToOffers': 'חזרה להצעות',
    'community.loadingOffer': 'טוען הצעה...',
    'community.offerNotFound': 'ההצעה לא נמצאה.',
    'community.makeOffer': 'שלח הצעה',
    'community.sendOffer': 'שלח הצעה',
    'community.sending': 'שולח...',
    'community.offerSent': 'ההצעה נשלחה',
    'community.offerSendFailed': 'שליחת ההצעה נכשלה',
    'community.noListedItems': 'אין פריטים מפורסמים זמינים.',
    'community.noOwnItems': 'אין לך פריטים להציע.',
    'community.dismissOffer': 'הסתר',
    'community.offerDismissed': 'ההצעה הוסתרה',
    'community.offerDismissFailed': 'הסתרת ההצעה נכשלה',

    // --- Notifications ---
    'notifications.title': 'התראות',
    'notifications.markAllRead': 'סמן הכל כנקרא',
    'notifications.empty': 'אין התראות',
    'notifications.emptyDesc': 'אתה מעודכן!',
    'notifications.offerReceived': 'הצעה חדשה התקבלה',
    'notifications.offerAccepted': 'ההצעה אושרה',
    'notifications.offerDeclined': 'ההצעה נדחתה',
    'notifications.offerWithdrawn': 'ההצעה בוטלה',
    'notifications.wantedMatch': 'התאמה לפריט מבוקש',
    'notifications.profileViewed': 'הפרופיל נצפה',
    'notifications.itemFavorited': 'פריט סומן כמועדף',

    // --- Favorites ---
    'favorites.add': 'הוסף למועדפים',
    'favorites.remove': 'הסר ממועדפים',
    'favorites.count': 'מועדפים',

    // --- AI Scan ---
    'aiScan.title': 'סריקה עם AI',
    'aiScan.optional': 'אופציונלי — צלם תמונה למילוי אוטומטי, או דלג ומלא את הטופס ידנית למטה.',
    'aiScan.dropText': 'גרור תמונה לכאן, או לחץ לעיון',
    'aiScan.dropHint': 'JPEG, PNG, או WebP — כל גודל. השתמש במצלמה בנייד.',
    'aiScan.analyze': 'נתח',
    'aiScan.analyzing': 'מנתח תמונה...',
    'aiScan.clear': 'נקה',
    'aiScan.prefilled': 'שדות הטופס מולאו מניתוח AI. בדוק לפני שמירה.',
    'aiScan.clickToEnlarge': 'לחץ להגדלה',
    'aiScan.imagePreview': 'תצוגת תמונה',
    'aiScan.failed': 'ניתוח AI נכשל. נסה שוב או מלא את הטופס ידנית.',
    'aiScan.lowConfidence': 'ודאות נמוכה — ייתכן שהתמונה אינה חומרת מחשוב רטרו. בדוק בקפידה.',
    'aiScan.notConfiguredTitle': 'זיהוי תמונות AI לא מוגדר',
    'aiScan.notConfiguredDesc': 'הזן את פרטי ה-API שלך כדי לאפשר זיהוי חומרה.',
    'aiScan.notConfiguredLink': 'פתח הגדרות',
    'aiScan.uploadTitle': 'הוסף תמונה',
    'aiScan.uploadSubtitle': 'אופציונלי — צרף תמונה לפריט זה, או דלג והוסף אחת מאוחר יותר.',
    'aiScan.uploadDropText': 'גרור תמונה לכאן, או לחץ לעיון',
    'aiScan.invalidType': 'רק תמונות JPEG, PNG ו-WebP מותרות.',
    'aiScan.tooLarge': 'הקובץ גדול מדי לעיבוד.',

    // --- Batch Upload ---
    'batch.title': 'הוספת פריטים מרובים',
    'batch.subtitle': 'גררו מספר תמונות לניתוח והוספה בבת אחת. סקרו כל פריט לפני השמירה.',
    'batch.dropText': 'גררו תמונות לכאן, או לחצו לבחירה',
    'batch.dropMore': 'גררו עוד תמונות להוספה לאצווה',
    'batch.dropHint': 'JPEG, PNG או WebP — ניתן לבחור מספר קבצים בו-זמנית',
    'batch.queued': 'בתור',
    'batch.analyzing': 'מנתח…',
    'batch.ready': 'מוכן',
    'batch.error': 'שגיאה',
    'batch.saving': 'שומר…',
    'batch.saved': 'נשמר',
    'batch.lowConfidence': 'ודאות נמוכה',
    'batch.retry': 'נסה שוב',
    'batch.remove': 'הסר',
    'batch.createAll': 'צור הכל ({count})',
    'batch.total': '{count} פריטים',
    'batch.analyzingCount': '{count} בניתוח',
    'batch.readyCount': '{count} מוכנים',
    'batch.savedCountLabel': '{count} נשמרו',
    'batch.savedCount': '{count} פריטים נוצרו בהצלחה',
    'batch.nameRequired': 'לכל הפריטים חייב להיות שם לפני השמירה.',
    'batch.saveFailed': 'שמירת הפריט נכשלה. ניתן לנסות שוב.',
    'batch.clearSaved': 'נקה שמורים',
    'batch.savingProgress': 'שומר פריטים... {done} מתוך {total} הושלמו',
    'batch.savingHint': 'ניתן לנווט לדף אחר — השמירה תמשיך ברקע.',
    'batch.allDone': 'כל {count} הפריטים נשמרו במלאי שלך.',
    'batch.doneWithErrors': '{saved} פריטים נשמרו, {errors} נכשלו. ניתן לנסות שוב.',
    'batch.viewInventory': 'צפה במלאי',

    // --- Support / Donation ---
    'support.sectionTitle': 'תמיכה',
    'support.cardTitle': 'קנו לי קבל',
    'support.cardBody': 'SiliconVault הוא חינמי — ללא עמלות, ללא פרסומות, ללא מנויים. המידע שלך לעולם אינו ממוסחר ואין מעקב אנליטי או שיתוף נתונים עם צדדים שלישיים. אם הוא עוזר לך לנהל את האוסף, שקול לתרום כדי לשמור על הפרויקט. הפרויקט ממומן אך ורק מתרומות וולונטריות.',
    'support.infraTitle': 'תשתית',
    'support.infraVercel': 'Vercel — אחסון ו-CDN',
    'support.infraNeon': 'Neon — מסד נתונים PostgreSQL',
    'support.infraAzure': 'Azure OpenAI — זיהוי באמצעות AI',
    'support.infraBrowserbase': 'Browserbase — בדיקות אפליקציה',
    'support.cardCosts': 'התרומות מופנות ישירות לעלויות השירותים האלה. לא לשום דבר אחר.',
    'support.ctaButton': 'תמכו בפרויקט',
    'support.footerLink': 'תמכו בפרויקט',

    // --- Terms of Service ---
    'terms.title': 'תנאי שימוש',
    'terms.lastUpdated': 'עדכון אחרון: מרץ 2026',
    'terms.acceptanceTitle': 'קבלת התנאים',
    'terms.acceptanceBody': 'בגישה או שימוש ב-SiliconVault, אתה מסכים להיות כפוף לתנאי שימוש אלו ולמדיניות ההחזרים שלנו. אם אינך מסכים לתנאים, אנא אל תשתמש בפלטפורמה. תנאים אלו חלים על כל שכבות השירות, כולל השכבה החינמית באינטרנט, מנויי Pro ואפליקציית שולחן העבודה.',
    'terms.accountTitle': 'אחריות החשבון',
    'terms.accountBody': 'אתה אחראי לשמירה על סודיות פרטי החשבון שלך ועל כל הפעילויות המתבצעות תחת חשבונך. אתה מתחייב לספק מידע מדויק בעת ההרשמה ולעדכן את פרטי החשבון שלך.',
    'terms.useTitle': 'שימוש מותר',
    'terms.useBody': 'אתה מסכים להשתמש ב-SiliconVault רק למטרות חוקיות הקשורות לניהול ושיתוף אוספי מחשוב רטרו. אין להשתמש בפלטפורמה לפרסום מודעות כוזבות, הטרדת משתמשים, הפצת תוכנות זדוניות או כל פעילות המפרה את החוק.',
    'terms.contentTitle': 'תוכן משתמש',
    'terms.contentBody': 'אתה שומר על הבעלות על כל התוכן שאתה מעלה ל-SiliconVault, כולל תמונות, תיאורים ומסמכים. בהעלאת תוכן, אתה מעניק ל-SiliconVault רישיון מוגבל להציג אותו בפלטפורמה לצורך מתן השירות. אתה אחראי לוודא שיש לך זכות לשתף כל תוכן שאתה מעלה.',
    'terms.paidServicesTitle': 'שירותים בתשלום וחיוב',
    'terms.paidServicesBody': 'SiliconVault מציעה שירותים בתשלום הכוללים מנויי Pro (מתחדשים) ורכישה חד-פעמית של אפליקציית שולחן העבודה. מנויי Pro מתחדשים אוטומטית בתום כל תקופת חיוב אלא אם בוטלו לפני מועד החידוש. באפשרותך לבטל את מנוי ה-Pro בכל עת מהגדרות החשבון; הביטול נכנס לתוקף בתום תקופת החיוב הנוכחית והגישה נשמרת עד אז. רישיונות שולחן העבודה הם לצמיתות ומוענקים למשתמש בודד עם הרכישה. כל המחירים בדולר ארה"ב וכפופים לשינוי עם הודעה מראש של 30 יום למנויים פעילים. התשלום מעובד על ידי Lemon Squeezy, הסוחר הרשום שלנו. ברכישה, אתה מסכים לתנאי השימוש של Lemon Squeezy. החזרים כפופים למדיניות ההחזרים שלנו.',
    'terms.ipTitle': 'קניין רוחני',
    'terms.ipBody': 'SiliconVault, כולל העיצוב, הקוד והמיתוג, היא תוכנה קניינית בבעלות אסף סער. אין להעתיק, לשנות, להפיץ או לבצע הנדסה הפוכה על כל חלק מהפלטפורמה ללא אישור כתוב מפורש.',
    'terms.liabilityTitle': 'הגבלת אחריות',
    'terms.liabilityBody': 'SiliconVault מסופק "כמות שהוא" ללא אחריות מכל סוג, בין אם מפורשת או משתמעת, כולל אך לא רק אחריות לסחירות, התאמה למטרה מסוימת או אי-הפרה. בעל הפלטפורמה אינו אחראי לנזקים ישירים, עקיפים, מקריים, מיוחדים, תוצאתיים או עונשיים הנובעים משימוש בשירות, כולל אך לא רק אובדן מידע, הפסד כספי מעסקאות בין משתמשים, אובדן רווחים או נזקי רכוש. עבור שירותים בתשלום, האחריות הכוללת לא תעלה על הסכום ששילמת בשנים-עשר (12) החודשים שקדמו לתביעה.',
    'terms.terminationTitle': 'סיום',
    'terms.terminationBody': 'אנו שומרים את הזכות להשעות או לסגור חשבונות שמפרים תנאים אלו. תוכל למחוק את חשבונך בכל עת. עם סיום, המידע שלך יימחק מהמערכות שלנו, אך תוכל לייצא אותו מראש. אם יש לך מנוי Pro פעיל, סיום מצידנו עקב הפרה (לדוגמה, הפרת תנאים) אינו מזכה בהחזר עבור יתרת תקופת החיוב. אם תבטל את חשבונך בעצמך, מנוי ה-Pro לא יתחדש והגישה תימשך עד תום התקופה ששולמה. רישיונות שולחן העבודה נשארים בתוקף לאחר מחיקת חשבון אך אינם ניתנים להעברה.',
    'terms.modificationsTitle': 'שינויים',
    'terms.modificationsBody': 'אנו עשויים לעדכן תנאים אלו מעת לעת. המשך השימוש ב-SiliconVault לאחר שינויים מהווה הסכמה לתנאים המעודכנים. שינויים מהותיים יועברו דרך הפלטפורמה.',
    'terms.governingTitle': 'דין חל',
    'terms.governingBody': 'תנאים אלו כפופים לחוקי מדינת ישראל. כל סכסוך יוכרע בבתי המשפט המוסמכים בתל אביב-יפו.',

    // --- Privacy Policy ---
    'privacy.title': 'מדיניות פרטיות',
    'privacy.lastUpdated': 'עדכון אחרון: מרץ 2026',
    'privacy.introTitle': 'מבוא',
    'privacy.introBody': 'SiliconVault מחויבת להגנה על פרטיותך. מדיניות זו מסבירה אילו נתונים אנו אוספים, כיצד אנו משתמשים בהם ומהן הזכויות שלך בנוגע למידע האישי שלך.',
    'privacy.collectTitle': 'מה אנחנו אוספים',
    'privacy.collectBody': 'אנו אוספים את המידע המינימלי הנדרש לספק את השירות: כתובת הדוא"ל ושם התצוגה שלך (ליצירת חשבון), נתוני האוסף שלך (פריטים, תמונות, מסמכים שהעלית), ולוגים בסיסיים של שימוש (לאבטחה ותיקון תקלות). אם רכשת מנוי Pro או רישיון שולחן עבודה, מעבד התשלומים שלנו (Lemon Squeezy) אוסף פרטי חיוב בשמנו — איננו מאחסנים את מספר כרטיס האשראי המלא או פרטי תשלום בשרתים שלנו. איננו אוספים נתוני מיקום גיאוגרפי מדויקים.',
    'privacy.useDataTitle': 'כיצד אנו משתמשים במידע',
    'privacy.useDataBody': 'המידע שלך משמש אך ורק לספק ולשפר את שירות SiliconVault. נתוני האוסף מאוחסנים כדי להפעיל את המלאי, מעקב תחזוקה וחלון הראווה. לוגי שימוש מסייעים לנו לזהות ולתקן תקלות.',
    'privacy.notDoTitle': 'מה אנחנו לא עושים',
    'privacy.notDoBody': 'איננו מוכרים את המידע שלך לצדדים שלישיים. איננו משתמשים במידע שלך לפרסום או שיווק. איננו חולקים את המידע האישי שלך עם צדדים שלישיים אלא אם נדרש בחוק. איננו משתמשים בנתוני האוסף שלך לאימון מודלים של AI.',
    'privacy.cookiesTitle': 'עוגיות',
    'privacy.cookiesBody': 'SiliconVault משתמש בעוגיית אימות httpOnly אחת בלבד (vault_token) לשמירת הפעלת ההתחברות שלך. איננו משתמשים בעוגיות מעקב, עוגיות אנליטיקה או שירותי עוגיות של צד שלישי.',
    'privacy.retentionTitle': 'שמירת מידע',
    'privacy.retentionBody': 'המידע שלך נשמר כל עוד החשבון שלך פעיל. אם תמחק את חשבונך, כל המידע המשויך יוסר לצמיתות מהמערכות שלנו. גיבויים עשויים לשמור מידע עד 30 יום לאחר המחיקה.',
    'privacy.exportTitle': 'ייצוא וניידות מידע',
    'privacy.exportBody': 'תוכל לייצא את כל האוסף שלך ל-CSV, JSON, או קטלוג PDF בכל עת מדף המלאי. המידע שלך תמיד שלך לקחת.',
    'privacy.thirdPartyTitle': 'שירותי צד שלישי',
    'privacy.thirdPartyBody': 'SiliconVault משתמש בשירותי צד שלישי הבאים: Vercel (אחסון ופריסה), Neon (אחסון מסד נתונים PostgreSQL), Azure OpenAI (זיהוי פריטים בעזרת AI), ו-Lemon Squeezy (עיבוד תשלומים וסוחר רשום עבור מנויי Pro ורכישות שולחן העבודה). שירותים אלו מעבדים מידע רק לפי הצורך לספק את הפונקציות שלהם ומחויבים למדיניות הפרטיות שלהם.',
    'privacy.paymentTitle': 'נתוני תשלום',
    'privacy.paymentBody': 'כל עסקאות התשלום מטופלות על ידי Lemon Squeezy כסוחר הרשום שלנו. אנו מקבלים רק את המידע הנדרש למילוי ההזמנה: כתובת הדוא"ל שלך, מזהה עסקה, סטטוס מנוי ומפתח רישיון. איננו מקבלים, מעבדים או מאחסנים את מספר כרטיס האשראי, פרטי חשבון הבנק או אישורי תשלום רגישים אחרים. לשאלות על אופן הטיפול בנתוני התשלום שלך, אנא עיינו במדיניות הפרטיות של Lemon Squeezy.',
    'privacy.securityTitle': 'אבטחה',
    'privacy.securityBody': 'אנו מגנים על המידע שלך באמצעות אמצעי אבטחה תקניים: סיסמאות מוצפנות ב-bcrypt, אימות באמצעות JWT tokens מאובטחים בעוגיות httpOnly, כל החיבורים מוצפנים ב-TLS, והעלאות קבצים מאומתות ומסוננות.',
    'privacy.contactTitle': 'יצירת קשר',
    'privacy.contactBody': 'לשאלות או בקשות בנוגע לפרטיות, צרו קשר בכתובת info@corgimind.com.',

    // --- Refund Policy ---
    'refund.title': 'מדיניות החזרים',
    'refund.lastUpdated': 'עדכון אחרון: מרץ 2026',
    'refund.overviewTitle': 'סקירה',
    'refund.overviewBody': 'SiliconVault Desktop הוא רכישה חד-פעמית (50$ USD) המעניקה גישה לכל החיים לאפליקציה. מנויי Pro מחויבים על בסיס מתחדש. פלטפורמת האינטרנט מציעה שכבה חינמית שאינה כרוכה בתשלום. אנו מציעים חלון החזר של 14 יום לרכישות אפליקציית שולחן העבודה — אם אינך מרוצה, תוכל לבקש החזר מלא תוך 14 יום ממועד הרכישה. ניתן לבטל מנויי Pro בכל עת; לא יינתנו החזרים עבור תקופות חיוב חלקיות, אך הגישה נשמרת עד תום התקופה ששולמה.',
    'refund.eligibilityTitle': 'זכאות',
    'refund.eligibilityBody': 'לרכישות שולחן העבודה, אתה זכאי להחזר אם הבקשה מוגשת תוך 14 יום ממועד הרכישה המקורי. ההחזרים מוגבלים לאחד לכל לקוח. למנויי Pro, באפשרותך לבטל בכל עת למניעת חיובים עתידיים; לא יינתנו החזרים עבור תקופות חלקיות. אנו שומרים את הזכות לדחות בקשות החזר המעידות על ניצול לרעה של מדיניות זו (למשל, מחזורי רכישה-והחזר חוזרים).',
    'refund.howToTitle': 'כיצד לבקש החזר',
    'refund.howToBody': 'לבקשת החזר, שלחו דוא"ל לכתובת info@corgimind.com עם שורת הנושא "בקשת החזר" וכללו את כתובת הדוא"ל של הרכישה ומספר ההזמנה. אנו שואפים להשיב לכל בקשות ההחזר תוך 2 ימי עסקים.',
    'refund.processingTitle': 'עיבוד',
    'refund.processingBody': 'החזרים מאושרים מעובדים דרך Lemon Squeezy (מעבד התשלומים שלנו) ומוחזרים לאמצעי התשלום המקורי. אנא המתינו 5–10 ימי עסקים עד שההחזר יופיע בדף החשבון שלכם. עם ההחזר, מפתח הרישיון שלכם יבוטל אוטומטית ואפליקציית שולחן העבודה לא תקבל אותו יותר להפעלה.',
    'refund.exceptionsTitle': 'חריגים',
    'refund.exceptionsBody': 'החזרים עשויים להידחות במקרי חשד להונאה או ניצול לרעה, כולל אך לא רק: בקשות החזר חוזרות ממספר חשבונות, ניסיונות להשתמש בתוכנה לאחר בקשת החזר, או הגשת צ\'ארג\'בק במקביל לבקשת החזר.',
    'refund.contactTitle': 'יצירת קשר',
    'refund.contactBody': 'לכל שאלה בנוגע להחזרים או חיובים, צרו קשר בכתובת info@corgimind.com.',

    // --- Stats ---
    'stats.title': 'סטטיסטיקת אוסף',
    'stats.noData': 'אין נתונים זמינים',
    'stats.emptyTitle': 'אין סטטיסטיקה עדיין',
    'stats.emptyDesc': 'הוסף פריטים לאוסף שלך כדי לראות ניתוחים ותרשימים.',
    'stats.totalItems': 'סה"כ פריטים',
    'stats.totalValue': 'ערך כולל',
    'stats.uniquePlatforms': 'פלטפורמות',
    'stats.uniqueCategories': 'קטגוריות',
    'stats.platformDistribution': 'התפלגות לפי פלטפורמה',
    'stats.conditionBreakdown': 'התפלגות לפי מצב',
    'stats.acquisitionTimeline': 'ציר זמן רכישות (12 חודשים)',
    'stats.valueByCategory': 'ערך לפי קטגוריה',

    // --- Activity Feed ---
    'activity.title': 'פיד פעילות',
    'activity.emptyTitle': 'אין פעילות עדיין',
    'activity.emptyDesc': 'אירועי קהילה יופיעו כאן כשאספנים מפרסמים פריטים, מבצעים החלפות ומצטרפים.',
    'activity.filter.all': 'הכל',
    'activity.filter.item_listed': 'פרסומים',
    'activity.filter.trade_completed': 'החלפות',
    'activity.filter.member_joined': 'חברים חדשים',
    'activity.filter.item_showcased': 'תצוגה',
    'activity.event.item_listed': 'פרסם פריט',
    'activity.event.trade_completed': 'השלים החלפה',
    'activity.event.member_joined': 'הצטרף לקהילה',
    'activity.event.item_showcased': 'הציג פריט',

    // --- Messaging ---
    'messages.title': 'הודעות',
    'messages.emptyTitle': 'אין שיחות',
    'messages.emptyDesc': 'התחל שיחה על ידי שליחת הודעה לאספן אחר מדף הפרופיל שלו.',
    'messages.selectConversation': 'בחר שיחה',
    'messages.noMessages': 'אין הודעות עדיין',
    'messages.startConversation': 'שלח הודעה כדי להתחיל את השיחה',
    'messages.placeholder': 'הקלד הודעה...',
    'messages.sendMessage': 'שלח הודעה',

    // --- Duplicates ---
    'duplicates.title': 'זיהוי כפולים',
    'duplicates.scan': 'סרוק כפולים',
    'duplicates.scanning': 'סורק...',
    'duplicates.scanPromptTitle': 'מצא פריטים כפולים',
    'duplicates.scanPromptDesc': 'לחץ על "סרוק כפולים" כדי לזהות פריטים עם שמות דומים באוסף שלך.',
    'duplicates.noneFound': 'לא נמצאו כפולים',
    'duplicates.noneFoundDesc': 'האוסף שלך נקי! לא זוהו כפולים פוטנציאליים.',
    'duplicates.pairsFound': 'כפולים פוטנציאליים נמצאו',
    'duplicates.match': 'התאמה',
    'duplicates.notDuplicate': 'לא כפול',
    'duplicates.keepLeft': 'השאר שמאל',
    'duplicates.keepRight': 'השאר ימין',
    'duplicates.confirmKeep': 'לחץ שוב לאישור',

    // --- Sets ---
    'nav.sets': 'סטים',
    'breadcrumb.sets': 'סטים',
    'breadcrumb.setDetail': 'פרטי סט',
    'sets.title': 'סטים של אוסף',
    'sets.createSet': 'סט חדש',
    'sets.newSet': 'סט חדש',
    'sets.setName': 'שם',
    'sets.setNamePlaceholder': 'לדוגמה, אוסף Commodore מלא',
    'sets.description': 'תיאור',
    'sets.descriptionPlaceholder': 'תיאור אופציונלי...',
    'sets.fromTemplate': 'מתבנית',
    'sets.customSet': 'מותאם אישית (סט ריק)',
    'sets.create': 'צור',
    'sets.emptyTitle': 'אין סטים עדיין',
    'sets.emptyDesc': 'צור סט אוסף כדי לעקוב אחרי אילו פריטים יש לך מאוסף יעד.',
    'sets.autoMatch': 'התאמה אוטומטית',
    'sets.matching': 'מתאים...',
    'sets.delete': 'מחק',
    'sets.confirmDelete': 'אשר מחיקה',
    'sets.itemsMatched': 'פריטים הותאמו מהמלאי שלך',
    'sets.noMatchesFound': 'לא נמצאו התאמות',
    'sets.addItemPlaceholder': 'הוסף פריט לסט...',
    'common.loading': 'טוען...',
    'common.notFound': 'לא נמצא.',
    'common.previous': 'הקודם',
    'common.next': 'הבא',

    // --- Landing page — Desktop section ---
    'landing.desktopTitle': 'רוצה שליטה מלאה?',
    'landing.desktopSub': 'האוסף שלך אצלך. המידע נשאר על המחשב שלך — בלי ענן, בלי מנויים, בלי פשרות.',
    'landing.desktopFeature1Title': 'מקומי לחלוטין',
    'landing.desktopFeature1Desc': 'הנתונים על המכשיר שלך. אין צורך באינטרנט לאחר ההתקנה.',
    'landing.desktopFeature2Title': 'רכישה חד-פעמית',
    'landing.desktopFeature2Desc': '$50 — שלך לנצח. ללא עלויות חוזרות.',
    'landing.desktopFeature3Title': 'חוצה פלטפורמות',
    'landing.desktopFeature3Desc': 'זמין ל-macOS, Windows ו-Linux.',
    'landing.desktopCta': 'למידע נוסף והורדה',

    // --- Download page ---
    'download.heroTitle': 'SiliconVault Desktop',
    'download.heroTagline': 'מקומי. פרטי. קבוע.',
    'download.priceBadge': '$50 — רכישה חד-פעמית, שלך לתמיד',
    'download.platformsTitle': 'הורדה',
    'download.macTitle': 'macOS',
    'download.macDesc': 'Universal (Apple Silicon + Intel), macOS 11+',
    'download.macButton': 'הורדה',
    'download.winTitle': 'Windows',
    'download.winDesc': 'Windows 10/11, x64',
    'download.winButton': 'הורדה',
    'download.linuxTitle': 'Linux',
    'download.linuxDesc': 'x64 — AppImage ו-.deb',
    'download.linuxButton': 'הורדה',
    'download.featuresTitle': 'למה דסקטופ?',
    'download.feature1Title': 'לא מקוון באופן מלא',
    'download.feature1Desc': 'כל האוסף שלך שמור במסד נתונים מקומי. לאחר ההתקנה, אין צורך בחיבור לאינטרנט.',
    'download.feature2Title': 'המידע שלך, המחשב שלך',
    'download.feature2Desc': 'שום דבר לא עוזב את המחשב שלך. ללא סנכרון ענן, ללא טלמטריה, ללא גישה של צד שלישי.',
    'download.feature3Title': 'AI עם המפתח שלך',
    'download.feature3Desc': 'השתמש במפתח OpenAI או Azure שלך לזיהוי חומרה. המפתח שלך, העלויות שלך, השליטה שלך.',
    'download.feature4Title': 'ייצוא בכל עת',
    'download.feature4Desc': 'ייצא את כל האוסף שלך כ-CSV, JSON, או קטלוג PDF מתי שתרצה. המידע שלך תמיד נייד.',
    'download.feature5Title': 'מסד נתונים מקומי',
    'download.feature5Desc': 'מסד נתונים מוטבע ומוכח. ללא שרת, ללא הגדרות — רק המידע שלך בקובץ אחד.',
    'download.feature6Title': 'ללא מעקב',
    'download.feature6Desc': 'אפס אנליטיקס, אפס מעקב, אפס שליחת נתונים. האפליקציה לעולם לא יוצרת קשר עם שרת אלא אם ביקשת.',
    'download.howTitle': 'איך זה עובד',
    'download.step1': 'הורד את המתקין לפלטפורמה שלך',
    'download.step2': 'התקן והפעל את SiliconVault Desktop',
    'download.step3': 'הזן את מפתח הרישיון שלך',
    'download.step4': 'התחל לקטלג — מקומי לחלוטין',
    'download.purchaseTitle': 'השג את הרישיון שלך',
    'download.purchaseDesc': 'רכוש מפתח רישיון כדי לפתוח את SiliconVault Desktop. המפתח יוצג מיד לאחר התשלום.',
    'download.licenseCardDesc': 'רכישה חד-פעמית. ללא מנוי. מפתח הרישיון מועבר מיד לאחר התשלום.',
    'download.purchaseButton': 'רכוש רישיון — $50',
    'download.footer': 'כל הזכויות שמורות.',

    // --- Download success page ---
    'download.successTitle': 'הרכישה הושלמה!',
    'download.successTagline': 'רישיון SiliconVault Desktop שלך מוכן.',
    'download.successLicenseLabel': 'מפתח הרישיון שלך',
    'download.successCopy': 'העתק ללוח',
    'download.successCopied': 'הועתק!',
    'download.successActivateTitle': 'איך להפעיל',
    'download.successStep1': 'הורד והתקן את SiliconVault Desktop לפלטפורמה שלך',
    'download.successStep2': 'הפעל את האפליקציה והזן את האימייל ומפתח הרישיון למעלה',
    'download.successStep3': 'התחל לקטלג את האוסף שלך — מקומי לחלוטין',
    'download.successLoading': 'מאחזר את מפתח הרישיון שלך...',
    'download.successErrorNoOrder': 'לא נמצא מזהה הזמנה. אנא בדוק את אישור הרכישה שלך.',
    'download.successErrorNotFound': 'הרישיון לא נמצא. ייתכן שנדרשת עיבוד — אנא רענן את הדף.',
    'download.successErrorGeneric': 'משהו השתבש. אנא נסה לרענן את הדף.',
    'download.successBackToDownload': 'חזרה להורדה',

    // --- About page — Desktop promo ---
    'about.desktopPromoTitle': 'SiliconVault Desktop',
    'about.desktopPromoBody': 'רוצה גישה מקומית? שלוט במידע שלך עם אפליקציית הדסקטופ — מקומית לחלוטין, ללא ענן.',
    'about.desktopPromoPrice': '$50 חד-פעמי',
    'about.desktopPromoCta': 'למידע נוסף',

    // --- Settings — Backup & Restore (desktop) ---
    'settings.backupRestore': 'גיבוי ושחזור',
    'settings.backupDesc': 'צור תמונת מצב של מסד הנתונים שלך. הגיבויים נשמרים מקומית לצד נתוני האפליקציה.',
    'settings.createBackup': 'צור גיבוי',
    'settings.creatingBackup': 'יוצר...',
    'settings.restoreBackup': 'שחזר',
    'settings.restoringBackup': 'משחזר...',
    'settings.deleteBackup': 'מחק',
    'settings.noBackups': 'אין גיבויים עדיין. צור גיבוי כדי להגן על המידע שלך.',
    'settings.backupCreated': 'הגיבוי נוצר בהצלחה.',
    'settings.backupRestored': 'מסד הנתונים שוחזר. נא להפעיל מחדש את האפליקציה.',
    'settings.backupDeleted': 'הגיבוי נמחק.',
    'settings.backupFailed': 'הגיבוי נכשל.',
    'settings.restoreFailed': 'השחזור נכשל.',
    'settings.confirmRestore': 'האם אתה בטוח? מסד הנתונים הנוכחי יוחלף בגיבוי זה. תמונת מצב בטיחותית תיווצר אוטומטית. יש להפעיל מחדש את האפליקציה.',
    'settings.confirmDelete': 'למחוק את הגיבוי הזה? פעולה זו אינה ניתנת לביטול.',
    'settings.schemaWarning': 'אזהרה: גיבוי זה נוצר על סכמת מסד נתונים ישנה יותר (גרסה {backupVersion}, הנוכחית היא {currentVersion}). לאחר השחזור, האפליקציה תחיל מחדש את המיגרציות החדשות בהפעלה הבאה. נתונים שנוספו על ידי מיגרציות אלו יאופסו לברירת מחדל.',

    // --- Settings — Desktop promo ---
    'settings.desktopPromoText': 'מחפש גישה מקומית? גלה את אפליקציית הדסקטופ',
    'settings.desktopPromoCta': 'למידע נוסף →',

    // --- PDF Export ---
    'pdf.modalTitle': 'ייצוא קטלוג PDF',
    'pdf.layoutPrompt': 'בחר פריסת אריחים לקטלוג:',
    'pdf.layout_large': 'גדול',
    'pdf.layout_compact': 'קומפקטי',
    'pdf.layout_dense': 'צפוף',
    'pdf.generate': 'צור PDF',
    'pdf.generating': 'מייצר...',
    'pdf.fetchingImages': 'טוען תמונות...',
    'pdf.orientation': 'כיוון',
    'pdf.portrait': 'לאורך',
    'pdf.landscape': 'לרוחב',

    // --- Share / Public Catalog ---
    'share.title': 'שתף את הקטלוג שלך',
    'share.shareCatalog': 'שתף קטלוג',
    'share.copyLink': 'העתק קישור',
    'share.copied': 'הועתק!',
    'share.facebookCopied': 'הטקסט הועתק — הדבק אותו בפוסט הפייסבוק שלך',
    'share.shareVia': 'שתף דרך',
    'share.share': 'שתף',
    'share.defaultMessage': 'בדקו את אוסף המחשבים הרטרו שלי ב-SiliconVault: {url}',
    'share.noSlug': 'צריך כתובת פרופיל כדי לשתף את הקטלוג.',
    'share.goToSettings': 'הגדר בהגדרות',
    'share.backToDashboard': 'לוח בקרה',
    'share.joinToMessage': 'הצטרף כדי לשלוח הודעה',
    'share.ctaHeadline': 'קיבלת השראה מהאוסף? צור קטלוג רטרו משלך',
    'share.ctaSubtext': 'SiliconVault חינמי לכל אספני מחשבי הרטרו.',
    'share.ctaButton': 'הרשמה חינם',
    'share.publicCatalog': 'קטלוג ציבורי',
    'share.yourPublicUrl': 'הכתובת הציבורית שלך',
    'share.viewProfile': 'צפה בפרופיל',
    'share.noSlugTitle': 'לא הוגדרה כתובת פרופיל',
    'share.noSlugSettingsDesc': 'הגדר כתובת פרופיל בחלק "פרופיל ציבורי" למעלה כדי לאפשר שיתוף קטלוג ציבורי.',
    'share.setSlugToShare': 'הגדר כתובת פרופיל למעלה כדי לאפשר שיתוף.',
    'share.catalogViews': 'צפיות בקטלוג',
    'share.totalViews': 'סה"כ',
    'share.thisWeek': 'השבוע',
    'share.thisMonth': 'החודש',
    'share.topReferrers': 'מפנים מובילים',
    'share.directVisit': 'ישיר',
    'share.ctaSocialProof': 'הצטרף ל-{collectors} אספנים שמשתפים {items} פריטים',
    'share.dashboardBannerTitle': 'שתף את האוסף שלך',
    'share.dashboardBannerDesc': 'תן לאחרים לגלות את קטלוג מחשבי הרטרו שלך',
    'share.dashboardBannerCta': 'שתף עכשיו',
    'share.inventoryShareBtn': 'שתף',
    'share.sharedVaults': 'כספות משותפות',
    'share.sharedVaultsHint': 'בחר אילו כספות יהיו גלויות בפרופיל הציבורי שלך.',
    'share.allVaults': 'הכל',
    'share.noPublicVaults': 'לאספן זה אין כספות ציבוריות.',

    // --- Landing page social proof ---
    'landing.socialProof': 'הצטרף ל-{collectors} אספנים שמקטלגים {items} פריטים',

    // --- Pricing page ---
    'pricing.heroTitle': 'מחירים פשוטים ושקופים',
    'pricing.heroTagline': 'התחל בחינם. שדרג כשתצטרך יותר.',
    'pricing.footerLink': 'מחירים',
    'pricing.freeName': 'חינם',
    'pricing.freeDesc': 'כל מה שצריך כדי להתחיל לקטלג את אוסף הרטרו שלך.',
    'pricing.freePrice': '$0',
    'pricing.freeSubtext': 'חינם לנצח',
    'pricing.freeFeature1': 'עד 100 פריטים',
    'pricing.freeFeature2': 'סוג כספת אחד',
    'pricing.freeFeature3': 'העלאת תמונות',
    'pricing.freeFeature4': 'כל 15 ערכות הנושא',
    'pricing.freeFeature5': '5 פריטים בתצוגה',
    'pricing.freeFeature6': 'סטים ואוספים',
    'pricing.freeFeature7': '5 סריקות AI בחודש + ללא הגבלה עם מפתח שלך',
    'pricing.freeFeature8': 'ייצוא CSV ו-JSON',
    'pricing.freeFeature9': 'ייצוא PDF',
    'pricing.freeCta': 'התחל עכשיו',
    'pricing.proName': 'Pro',
    'pricing.proDesc': 'ניהול אוסף ללא הגבלה עם ניתוח AI מתקדם.',
    'pricing.popularBadge': 'הכי פופולרי',
    'pricing.monthly': 'חודשי',
    'pricing.yearly': 'שנתי',
    'pricing.perMonth': '/חודש',
    'pricing.perYear': '/שנה',
    'pricing.saveBadge': 'חיסכון 33%',
    'pricing.monthlySubtext': 'חיוב חודשי',
    'pricing.yearlySubtext': '$40 חיוב שנתי',
    'pricing.proFeature1': 'פריטים ללא הגבלה',
    'pricing.proFeature2': 'כל סוגי הכספות',
    'pricing.proFeature3': 'ייצוא CSV, JSON ו-PDF',
    'pricing.proFeature4': 'כל 15 ערכות הנושא',
    'pricing.proFeature5': 'תצוגה ללא הגבלה',
    'pricing.proFeature6': '500 סריקות AI בחודש + ללא הגבלה עם מפתח שלך',
    'pricing.proFeature7': 'סטים ואוספים',
    'pricing.proCta': 'שדרג ל-Pro',
    'pricing.proCtaLoading': 'טוען...',
    'pricing.desktopName': 'דסקטופ',
    'pricing.desktopDesc': 'מקומי לחלוטין. המידע שלך נשאר על המחשב.',
    'pricing.desktopSubtext': 'רכישה חד-פעמית',
    'pricing.desktopFeature1': 'פריטים מקומיים ללא הגבלה',
    'pricing.desktopFeature2': 'העלאת תמונות',
    'pricing.desktopFeature3': 'ייצוא CSV, JSON ו-PDF',
    'pricing.desktopFeature4': 'כל 15 ערכות הנושא',
    'pricing.desktopFeature5': 'כל סוגי הכספות',
    'pricing.desktopFeature6': 'AI עם מפתח API שלך',
    'pricing.desktopFeature7': 'מקומי לחלוטין — ללא חשבון',
    'pricing.desktopFeature8': 'התקנה על Windows, Mac ו-Linux',
    'pricing.desktopCta': 'רכוש דסקטופ — $50',

    // --- Upgrade page (in-app) ---
    'upgrade.title': 'התוכנית שלך',
    'upgrade.subtitle': 'נהל את המנוי שלך וצפה במה שכלול.',
    'upgrade.currentPlan': 'תוכנית נוכחית',
    'upgrade.freeBadge': 'חינם',
    'upgrade.itemsUsed': 'פריטים',
    'upgrade.compareTitle': 'חינם מול Pro',
    'upgrade.feature': 'תכונה',
    'upgrade.freeCol': 'חינם',
    'upgrade.proCol': 'Pro',
    'upgrade.featureItems': 'פריטים',
    'upgrade.freeItems': 'עד 100',
    'upgrade.proItems': 'ללא הגבלה',
    'upgrade.featureVaults': 'כספות',
    'upgrade.freeVaults': 'סוג אחד',
    'upgrade.proVaults': 'כל הסוגים',
    'upgrade.featureShowroom': 'תצוגה',
    'upgrade.freeShowroom': '5 פריטים',
    'upgrade.proShowroom': 'ללא הגבלה',
    'upgrade.featureAi': 'ניתוח AI',
    'upgrade.freeAi': '5/חודש + מפתח שלך',
    'upgrade.proAi': '500/חודש + מפתח שלך',
    'upgrade.featureExport': 'ייצוא',
    'upgrade.featureThemes': 'כל 15 ערכות הנושא',
    'upgrade.featureSets': 'סטים ואוספים',
    'upgrade.featureImages': 'העלאת תמונות',
    'upgrade.ctaTitle': 'שדרג ל-Pro',
    'upgrade.ctaPeriod': 'או $40/שנה — חיסכון 33%',
    'upgrade.ctaPeriodMonthly': 'חיוב חודשי, ביטול בכל עת',
    'upgrade.ctaPeriodYearly': '$40 חיוב שנתי',
    'upgrade.ctaButton': 'שדרג ל-Pro',
    'upgrade.ctaLoading': 'מפנה…',
    'upgrade.proActiveTitle': 'אתה על Pro',
    'upgrade.proActiveDesc': 'פריטים ללא הגבלה, תצוגה, ניתוח AI, וייצוא PDF.',
    'upgrade.analysesUsed': 'ניתוחים בשימוש',
    'upgrade.remaining': 'נותרו',
    'upgrade.resetsOn': 'מתאפס',
    'upgrade.sidebarBadge': 'תוכנית חינם',
    'upgrade.sidebarBadgePro': 'תוכנית Pro',
    'upgrade.dashboardBannerTitle': 'נגמר המקום',
    'upgrade.dashboardBannerDesc': 'השתמשת ב-{count} מתוך 100 פריטים. שדרג ל-Pro לפריטים ללא הגבלה.',
    'upgrade.dashboardBannerCta': 'שדרג ל-Pro',
    'upgrade.checkoutError': 'לא ניתן להתחיל תשלום. נסה שוב מאוחר יותר.',
    'upgrade.successTitle': 'ברוכים הבאים ל-Pro!',
    'upgrade.successDesc': 'המנוי שלך פעיל. תהנה מפריטים ללא הגבלה, תצוגה, ניתוח AI, וייצוא PDF.',
    'upgrade.desktopTitle': 'SiliconVault Desktop',
    'upgrade.desktopDesc': 'עובד אופליין לחלוטין. הנתונים נשארים על המחשב שלך. פריטים ללא הגבלה, ללא מנוי.',
    'upgrade.desktopPrice': '$50',
    'upgrade.desktopPriceSuffix': 'חד-פעמי',
    'batch.skipped': 'ידני',
    'batch.quotaExhausted': 'ניצלת את כל סריקות ה-AI החינמיות החודש. הפריטים הנותרים נוספו למילוי ידני. הגדר מפתח API משלך בהגדרות לסריקות ללא הגבלה, או שדרג ל-Pro.',
    'batch.quotaUpgrade': 'שדרג ל-Pro',
    'vaults.title': 'הכספות שלך',
    'vaults.subtitle': 'בחר כספת לניהול, או צור חדשה כדי להתחיל לאסוף.',
    'vaults.create': 'צור',
    'vaults.deleteTitle': 'מחק את "{name}"?',
    'vaults.deleteWarning': 'פעולה זו תמחק לצמיתות את הכספת הזו ואת כל פריטי המלאי, הסטים והפריטים המבוקשים שבתוכה. לא ניתן לבטל פעולה זו.',
    'vaults.deleteConfirmLabel': 'לאישור, הקלד "{confirmation}" למטה:',
    'vaults.deleteConfirmText': 'כן, מחק את הכספת הזו',
    'vaults.deleteBtn': 'מחק כספת',
    'vaults.deleting': 'מוחק...',
    'vaults.cancel': 'ביטול',
    'vaults.switchVault': 'החלף כספת',
    'vaults.manageVaults': 'ניהול כספות',
    'vaults.upgradeBadge': 'שדרג',
    'vaults.upgradeHint': 'תוכנית חינם מוגבלת לסוג כספת אחד. שדרג ל-Pro כדי לפתוח את כל סוגי הכספות.',
    'vaults.upgradeCta': 'שדרג ל-Pro',
    'vaults.type.retro_computers': 'מחשבי רטרו',
    'vaults.type.retro_audio': 'אודיו רטרו / Hi-Fi',
    'vaults.type.vintage_cameras': 'מצלמות וינטג\'',
    'vaults.type.watches': 'שעונים',
    'vaults.tagline.retro_computers': 'שמרו על המכונות שהתחילו את הכל',
    'vaults.tagline.retro_audio': 'קטלגו את מערכות הסאונד הוינטג\' שלכם',
    'vaults.tagline.vintage_cameras': 'תעדו את אוסף הצילום האנלוגי שלכם',
    'vaults.tagline.watches': 'עקבו אחרי אוסף השעונים שלכם',
    'upgrade.desktopCta': 'רכוש רישיון Desktop',
    'upgrade.desktopLoading': 'מפנה…',
    // אוסף מותאם אישית
    'vaults.customCard.title': 'אוסף מותאם אישית',
    'vaults.customCard.tagline': 'צרו כספת לכל סוג אוסף',
    'vaults.customCard.taglineShort': 'אוסף מותאם אישית',
    'vaults.custom.title': 'יצירת אוסף מותאם אישית',
    'vaults.custom.subtitle': 'עצבו כספת לכל סוג אוסף. הגדירו אילו שדות כל פריט צריך לעקוב.',
    'vaults.custom.backToVaults': 'חזרה לכספות',
    'vaults.custom.basicInfo': 'מידע בסיסי',
    'vaults.custom.vaultName': 'שם הכספת',
    'vaults.custom.vaultNamePlaceholder': 'לדוגמה: תקליטי ויניל, נעלי ספורט, קלפי אספנות',
    'vaults.custom.description': 'תיאור',
    'vaults.custom.descriptionPlaceholder': 'תארו על מה האוסף הזה. זה עוזר ל-AI לנתח את הפריטים שלכם בצורה מדויקת יותר.',
    'vaults.custom.platformLabel': 'תווית פלטפורמה / מותג',
    'vaults.custom.platformLabelPlaceholder': 'לדוגמה: מותג, מוציא לאור, לייבל',
    'vaults.custom.icon': 'אייקון',
    'vaults.custom.createVault': 'צור כספת',
    'vaults.custom.upgradeToCreate': 'שדרגו כדי ליצור אוספים מותאמים אישית',
    'vaults.custom.createFailed': 'יצירת הכספת נכשלה',
    // הגדרות כספת
    'vaults.settings.title': 'הגדרות כספת',
    'vaults.settings.subtitle': 'ערכו את השדות והמטא-דאטה של הכספת המותאמת אישית. שינויים חלים על פריטים חדשים — נתוני פריטים קיימים נשמרים.',
    'vaults.settings.backToDashboard': 'חזרה ללוח הבקרה',
    'vaults.settings.vaultInfo': 'פרטי הכספת',
    'vaults.settings.saveChanges': 'שמור שינויים',
    'vaults.settings.saved': 'ההגדרות נשמרו בהצלחה.',
    'vaults.settings.saveFailed': 'השמירה נכשלה',
    'vaults.settings.notCustom': 'הגדרות כספת זמינות רק לכספות מותאמות אישית.',
    'vaults.settings.navLabel': 'הגדרות כספת',
    // עורך שדות
    'fieldEditor.includedByDefault': 'כלולים כברירת מחדל',
    'fieldEditor.builtinToggle': 'כל פריט כולל אוטומטית את השדות האלה — אין צורך להוסיף אותם',
    'fieldEditor.groupCore': 'ליבה',
    'fieldEditor.groupStatus': 'סטטוס',
    'fieldEditor.groupFinancial': 'פיננסי',
    'fieldEditor.groupNotes': 'הערות',
    'fieldEditor.required': 'חובה',
    'fieldEditor.fieldName': 'שם',
    'fieldEditor.fieldCategory': 'קטגוריה',
    'fieldEditor.fieldSubcategory': 'תת-קטגוריה',
    'fieldEditor.fieldCondition': 'מצב',
    'fieldEditor.fieldLocation': 'מיקום',
    'fieldEditor.fieldAcquisition': 'תאריך ומחיר רכישה',
    'fieldEditor.fieldLaunch': 'תאריך ומחיר השקה',
    'fieldEditor.fieldDescription': 'תיאור',
    'fieldEditor.fieldCustomNotes': 'הערות נוספות',
    'fieldEditor.additionalFields': 'שדות נוספים',
    'fieldEditor.additionalFieldsDesc': 'הוסיפו שדות ספציפיים לאוסף שלכם. אלה מופיעים לצד השדות המובנים למעלה.',
    'fieldEditor.selectedFields': 'שדות נבחרים ({count}/20)',
    'fieldEditor.emptyFields': 'עדיין לא נוספו שדות. בחרו מהספרייה למעלה או צרו שדה מותאם אישית.',
    'fieldEditor.removeField': 'הסר שדה',
    'fieldEditor.addCustomField': 'הוסף שדה מותאם אישית',
    'fieldEditor.fieldLabel': 'תווית שדה',
    'fieldEditor.fieldLabelPlaceholder': 'לדוגמה: חומר המסגרת',
    'fieldEditor.fieldType': 'סוג',
    'fieldEditor.fieldKey': 'מפתח (נוצר אוטומטית)',
    'fieldEditor.fieldKeyPlaceholder': 'field_key',
    'fieldEditor.placeholderLabel': 'טקסט מציין מקום (אופציונלי)',
    'fieldEditor.placeholderPlaceholder': 'לדוגמה: הזינו ערך...',
    'fieldEditor.optionsLabel': 'אפשרויות (מינימום 2)',
    'fieldEditor.optionsPlaceholder': 'הקלידו אפשרות ולחצו Enter',
    'fieldEditor.addField': 'הוסף שדה',
    'fieldEditor.type.text': 'טקסט',
    'fieldEditor.type.number': 'מספר',
    'fieldEditor.type.select': 'רשימה נפתחת',
    'fieldEditor.type.date': 'תאריך',
    'fieldEditor.type.boolean': 'כן / לא',
    'fieldEditor.type.url': 'כתובת URL',
    'fieldEditor.warn.platform': 'השדה "{label}" כבר מכסה את זה. שקלו להתאים את תווית "{label}" במקום.',
    'fieldEditor.warn.description': 'שדה "תיאור" כבר כלול כברירת מחדל.',
    'fieldEditor.warn.notes': 'שדה "הערות נוספות" כבר כלול כברירת מחדל.',
    'fieldEditor.warn.name': 'שדה "שם" כבר כלול כברירת מחדל.',
    'fieldEditor.warn.category': 'שדה "קטגוריה" כבר כלול כברירת מחדל.',
    'fieldEditor.warn.condition': 'רשימה נפתחת "מצב" כבר כלולה כברירת מחדל.',
    'fieldEditor.warn.price': 'שדות מחיר רכישה ומחיר השקה כבר כלולים כברירת מחדל.',
    'fieldEditor.warn.location': 'שדה "מיקום" כבר כלול כברירת מחדל.',
    // קבוצות שדות מוגדרים מראש
    'fieldEditor.group.General': 'כללי',
    'fieldEditor.group.Electronics & Computing': 'אלקטרוניקה ומחשוב',
    'fieldEditor.group.Optics & Photography': 'אופטיקה וצילום',
    'fieldEditor.group.Horology': 'שענות',
    'fieldEditor.group.Collectibles & Trading': 'אספנות ומסחר',
    // תוויות שדות מוגדרים מראש
    'fieldEditor.predef.serial_number': 'מספר סידורי',
    'fieldEditor.predef.year': 'שנה',
    'fieldEditor.predef.color': 'צבע',
    'fieldEditor.predef.material': 'חומר',
    'fieldEditor.predef.weight': 'משקל',
    'fieldEditor.predef.dimensions': 'מידות',
    'fieldEditor.predef.edition': 'מהדורה',
    'fieldEditor.predef.country_of_origin': 'ארץ מקור',
    'fieldEditor.predef.manufacturer': 'יצרן',
    'fieldEditor.predef.rarity': 'נדירות',
    'fieldEditor.predef.certification': 'הסמכה / דירוג',
    'fieldEditor.predef.is_complete': 'סט שלם',
    'fieldEditor.predef.reference_url': 'קישור לעיון',
    'fieldEditor.predef.cpu': 'מעבד',
    'fieldEditor.predef.memory': 'זיכרון',
    'fieldEditor.predef.storage_capacity': 'נפח אחסון',
    'fieldEditor.predef.wattage': 'הספק (וואט)',
    'fieldEditor.predef.connectivity': 'חיבוריות',
    'fieldEditor.predef.lens_mount': 'תפס עדשה',
    'fieldEditor.predef.focal_length': 'אורך מוקד',
    'fieldEditor.predef.aperture_range': 'טווח צמצם',
    'fieldEditor.predef.film_format': 'פורמט פילם',
    'fieldEditor.predef.movement_type': 'סוג מנגנון',
    'fieldEditor.predef.case_material': 'חומר מארז',
    'fieldEditor.predef.case_diameter': 'קוטר מארז',
    'fieldEditor.predef.water_resistance': 'עמידות במים',
    'fieldEditor.predef.crystal_type': 'סוג זכוכית',
    'fieldEditor.predef.mint_mark': 'סימן מטבעה',
    'fieldEditor.predef.face_value': 'ערך נקוב',
    'fieldEditor.predef.denomination': 'ערך',
    'fieldEditor.predef.artist': 'אמן / מעצב',
    'fieldEditor.predef.issue_number': 'מספר גיליון',
    'fieldEditor.predef.print_run': 'מהדורת הדפסה',
    // תווית פלטפורמה ברירת מחדל
    'fieldEditor.defaultPlatformLabel': 'מותג',
    'settings.themeVivid': 'חי ותוסס',

    // --- משוב ---
    'nav.feedback': 'משוב',
    'feedback.title': 'משוב ותמיכה',
    'feedback.subtitle': 'דווחו על באגים, בקשו תכונות חדשות, או שתפו את דעתכם.',
    'feedback.typeBug': 'דיווח באג',
    'feedback.typeFeature': 'בקשת תכונה',
    'feedback.typeFeedback': 'משוב כללי',
    'feedback.typeQuestion': 'שאלה',
    'feedback.titleLabel': 'כותרת',
    'feedback.titlePlaceholder': 'תיאור קצר של המשוב',
    'feedback.descriptionLabel': 'תיאור',
    'feedback.descriptionPlaceholder': 'ספרו לנו עוד...',
    'feedback.submit': 'שלח משוב',
    'feedback.myTickets': 'הפניות שלי',
    'feedback.noTickets': 'אין פניות עדיין',
    'feedback.noTicketsDesc': 'משוב שתשלחו יופיע כאן.',
    'feedback.submitted': 'המשוב נשלח בהצלחה!',
    'feedback.statusOpen': 'פתוח',
    'feedback.statusInProgress': 'בטיפול',
    'feedback.statusResolved': 'טופל',
    'feedback.statusClosed': 'סגור',
    'feedback.adminReply': 'תגובת מנהל',
    'feedback.noReply': 'אין תגובה עדיין',

    // --- משוב - ניהול ---
    'admin.feedbackTab': 'משוב',
    'admin.feedback.title': 'משוב משתמשים',
    'admin.feedback.reply': 'תגובה',
    'admin.feedback.replyPlaceholder': 'כתוב תגובה...',
    'admin.feedback.sendReply': 'שלח תגובה',
    'admin.feedback.changeStatus': 'שנה סטטוס',
    'admin.feedback.noTickets': 'אין פניות משוב',
};

export default he;
